<template>
    <div class="affiliatePage">
        <page-navigate></page-navigate>
        <div class="pageShadow"></div>

        <div class="aff-section1">
            <div class="section1Container text-center">
                <picture>
                    <source srcset="@/assets/image/Affiliate/headerBg.webp" media="(min-width: 997px)" />
                    <img src="@/assets/image/Affiliate/headerBgM.webp" alt="" />
                </picture>
                <h1 class="headerTitle">EBC联盟伙伴</h1>
                <h2 class="headerDesc">
                    释放影响力的商业价值 ，让合作简单、高效、有趣，并创造更多可能 
                </h2>
                <a class="headerBtn primary-default_large flex justify-center items-center cursor-pointer"
                    href="javascript:void(0);" target="_blank">立即加入</a>
            </div>
        </div>
        <div class="aff-section2">
            <div class="contentBox section2-cardList flex justify-between items-center">
                <div class="section2-card">
                    <div class="section2-cardTitle">月交易量</div>
                    <div class="section2-cardDesc">390B+</div>
                </div>
                <div class="section2-card">
                    <div class="section2-cardTitle">顶级合作伙伴月佣金</div>
                    <div class="section2-cardDesc">$498K+</div>
                </div>
                <div class="section2-card">
                    <div class="section2-cardTitle">全球市场</div>
                    <div class="section2-cardDesc">100+</div>
                </div>
                <div class="section2-card">
                    <div class="section2-cardTitle">出入金</div>
                    <div class="section2-cardDesc">24H</div>
                </div>
            </div>
        </div>
        <div class="aff-section3">
            <div class="contentBox">
                <h2>成为联盟伙伴，能赚多少？</h2>
                <h3>每成功邀请一人，最高可获得约$730，拖动下方滑块查看对应佣金。</h3>
                <div class="container">
                    <div class="commission-title">您获得的佣金：</div>
                    <div class="commission-amount" id="commissionAmount">$110,960</div>

                    <div class="chart-wrapper">
                        <div class="chart-container" id="chartContainer">
                            <svg class="chart-svg" id="chartSvg" viewBox="0 0 1137 337" preserveAspectRatio="none">
                                <defs>
                                    <linearGradient id="paint0_linear" x1="1136" y1="168.389" x2="0" y2="168.389"
                                        gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#E8D5D6" stop-opacity="0.3" />
                                        <stop offset="0.2" stop-color="#E8D5D6" />
                                        <stop offset="1" stop-color="#E8D5D6" stop-opacity="0.3" />
                                    </linearGradient>
                                    <linearGradient id="paint1_linear_active" x1="0" y1="168.389" x2="1136" y2="168.389"
                                        gradientUnits="userSpaceOnUse">
                                        <stop offset="0" stop-color="#FFE5E6" />
                                        <stop offset="0.15" stop-color="#FFB3B5" />
                                        <stop offset="0.35" stop-color="#FF8385" />
                                        <stop offset="0.6" stop-color="#FF4B4E" />
                                        <stop offset="0.85" stop-color="#D43D40" />
                                        <stop offset="1" stop-color="#C4383B" />
                                    </linearGradient>
                                    <!-- 遮罩：用于隐藏曲线上方的虚线 -->
                                    <mask id="lineMask">
                                        <rect x="0" y="0" width="1137" height="337" fill="white" />
                                        <!-- 曲线上方区域设为黑色（隐藏），跟随曲线上移30px -->
                                        <path
                                            d="M0 306.388C180.763 306.388 803.601 239.758 1136 -29.611511 L1136 0 L0 0 Z"
                                            fill="black" />
                                    </mask>
                                </defs>

                                <!-- 虚线网格（应用遮罩，只显示在曲线下方）-->
                                <!-- 人数范围：50到1076，均分计算虚线位置 -->
                                <g mask="url(#lineMask)">
                                    <!-- 1人 -->
                                    <line x1="50" y1="0" x2="50" y2="337" stroke="#999999" stroke-width="1"
                                        stroke-dasharray="4,4" />
                                    <!-- 50人 -->
                                    <line x1="218" y1="0" x2="218" y2="337" stroke="#999999" stroke-width="1"
                                        stroke-dasharray="4,4" />
                                    <!-- 100人 -->
                                    <line x1="390" y1="0" x2="390" y2="337" stroke="#999999" stroke-width="1"
                                        stroke-dasharray="4,4" />
                                    <!-- 150人 -->
                                    <line x1="561" y1="0" x2="561" y2="337" stroke="#999999" stroke-width="1"
                                        stroke-dasharray="4,4" />
                                    <!-- 200人 -->
                                    <line x1="733" y1="0" x2="733" y2="337" stroke="#999999" stroke-width="1"
                                        stroke-dasharray="4,4" />
                                    <!-- 250人 -->
                                    <line x1="904" y1="0" x2="904" y2="337" stroke="#999999" stroke-width="1"
                                        stroke-dasharray="4,4" />
                                    <!-- 300人 -->
                                    <line x1="1076" y1="0" x2="1076" y2="337" stroke="#999999" stroke-width="1"
                                        stroke-dasharray="4,4" />
                                </g>

                                <!-- 背景路径（灰色淡色）- 整体上移30px -->
                                <path d="M0 306.388C180.763 306.388 803.601 239.758 1136 -29.611511"
                                    stroke="url(#paint0_linear)" stroke-width="2" fill="none" />

                                <!-- 激活路径（红色加粗），使用stroke-dasharray控制显示 - 整体上移30px -->
                                <path id="activePath" d="M0 306.388C180.763 306.388 803.601 239.758 1136 -29.611511"
                                    stroke="url(#paint1_linear_active)" stroke-width="4" fill="none"
                                    stroke-dasharray="0 10000" />
                            </svg>
                        </div>

                        <div class="x-axis" id="xAxis">
                            <span class="x-axis-label" data-people="1">1人</span>
                            <span class="x-axis-label" data-people="50">50人</span>
                            <span class="x-axis-label" data-people="100">100人</span>
                            <span class="x-axis-label" data-people="150">150人</span>
                            <span class="x-axis-label" data-people="200">200人</span>
                            <span class="x-axis-label" data-people="250">250人</span>
                            <span class="x-axis-label" data-people="300">300人</span>
                        </div>
                    </div>

                    <div class="footnote-regular_12 description">
                        *奖金计算基于实际销售，仅供参考与预测使用。实际佣金可能因地区政策及其他因素而有所不同。国际/国内市场数据有差异，请以实际到账佣金为准。
                    </div>
                </div>
            </div>
        </div>
        <div class="aff-section4">
            <div class="contentBox">
                <h2>覆盖全球的合作平台生态</h2>
                <h3>
                    我们与全球主流内容与流量平台建立深度合作，放大合作伙伴的长期价值。
                </h3>
                <div class="swiper section4Swiper pc">
                    <div class="shadow leftShadow"></div>
                    <div class="shadow rightShadow"></div>
                    <div class="swiper-wrapper flex items-center">
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/section4Logo1.svg" alt="" />
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/section4Logo2.svg" alt="" />
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/section4Logo3.svg" alt="" />
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/section4Logo4.svg" alt="" />
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/section4Logo5.svg" alt="" />
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/section4Logo6.svg" alt="" />
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/section4Logo7.svg" alt="" />
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/section4Logo8.svg" alt="" />
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/section4Logo9.svg" alt="" />
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/section4Logo10.svg" alt="" />
                        </div>
                    </div>
                </div>
                <div class="swiper section4SwiperM1 mobile">
                    <div class="shadow leftShadow"></div>
                    <div class="shadow rightShadow"></div>
                    <div class="swiper-wrapper flex items-center">
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/section4Logo1.svg" alt="" />
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/section4Logo2.svg" alt="" />
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/section4Logo3.svg" alt="" />
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/section4Logo4.svg" alt="" />
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/section4Logo5.svg" alt="" />
                        </div>
                    </div>
                </div>
                <div class="swiper section4SwiperM2 mobile">
                    <div class="shadow leftShadow"></div>
                    <div class="shadow rightShadow"></div>
                    <div class="swiper-wrapper flex items-center">
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/section4Logo6.svg" alt="" />
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/section4Logo7.svg" alt="" />
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/section4Logo8.svg" alt="" />
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/section4Logo9.svg" alt="" />
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/section4Logo10.svg" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="aff-section5">
            <div class="contentBox">
                <h2>只需 3 步，开始赚钱</h2>
                <a class="section5Btn flex justify-center items-center" href="javascript:void(0);" target="_blank">
                    立即加入
                    <span class="iconfont icon-right"></span>
                </a>
                <div class="section5CardList flex justify-center">
                    <div class="section5Card">
                        <img src="@/assets/image/Affiliate/section5Logo1.svg" alt="" />
                        <div>
                            <div class="cardTip">第 1 步：获取链接</div>
                            <div class="cardDesc">申请加入并发布您的联盟链接</div>
                        </div>
                    </div>
                    <div class="section5Card">
                        <img src="@/assets/image/Affiliate/section5Logo2.svg" alt="" />
                        <div>
                            <div class="cardTip">第 2 步：邀请客户</div>
                            <div class="cardDesc">客户通过您的链接入金并交易</div>
                        </div>
                    </div>
                    <div class="section5Card">
                        <img src="@/assets/image/Affiliate/section5Logo3.svg" alt="" />
                        <div>
                            <div class="cardTip">第 3 步：获得返佣</div>
                            <div class="cardDesc">赚取佣金并提现</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="aff-section6">
            <div class="contentBox">
                <h2>为联盟者打造的全球一体化服务</h2>
                <h3>
                    我们在英国、新加坡、马来西亚、澳大利亚、巴西、墨西哥、南非等国家和地区设有分公可与办事处，为全球
                    100+ 国家和地区的联盟伙伴提供专业、高效的本地化支持与服务。
                </h3>
                <div class="section6Map"></div>
                <div class="mapLegend flex justify-center items-center">
                    <div class="legendItem">
                        <img src="@/assets/image/Affiliate/section6LegendStar1.svg" alt="" />
                        <span class="legendLabel">服务覆盖的国家/地区</span>
                    </div>
                    <div class="legendItem">
                        <img src="@/assets/image/Affiliate/section6LegendStar2.svg" alt="" />
                        <span class="legendLabel">分公司/办事处</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="aff-section7">
            <div class="section7SwiperList">
                <div class="shadow leftShadow"></div>
                <div class="shadow rightShadow"></div>
                <div class="marquee section7Swiper1">
                    <div class="marquee__track flex items-center">
                        <div class="swiper-slide">
                            <div class="swiperWordTag">内容类</div>
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">二级联盟</div>
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/s7bLogo1.svg" alt="" class="swiperLogoTag" />
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">联盟网络</div>
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">优惠券</div>
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">返现</div>
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">比价网站</div>
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/s7pLogo1.svg" alt="" class="swiperLogoTag" />
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">社交媒体</div>
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/s7bLogo2.svg" alt="" class="swiperLogoTag" />
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">网红</div>
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">技术型流量</div>
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/s7bLogo3.svg" alt="" class="swiperLogoTag" />
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">视频</div>
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">CTV</div>
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">应用内</div>
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">APP流量</div>
                        </div>
                    </div>
                </div>
                <div class="marquee section7Swiper2">
                    <div class="marquee__track flex items-center marquee--reverse">
                        <div class="swiper-slide">
                            <div class="swiperWordTag">1对1专属联盟经理</div>
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/s7pLogo2.svg" alt="" class="swiperLogoTag" />
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">24小时多语言客服</div>
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/s7pLogo3.svg" alt="" class="swiperLogoTag" />
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">可定制物料</div>
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">Trading view</div>
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/s7pLogo4.svg" alt="" class="swiperLogoTag" />
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">订单流</div>
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">EA工具</div>
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">定制化扶持方案</div>
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/s7bLogo2.svg" alt="" class="swiperLogoTag" />
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">Demo账号</div>
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/s7pLogo1.svg" alt="" class="swiperLogoTag" />
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">多种营销活动</div>
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/s7bLogo3.svg" alt="" class="swiperLogoTag" />
                        </div>
                    </div>
                </div>
                <div class="marquee section7Swiper3">
                    <div class="marquee__track flex items-center">
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/s7bLogo1.svg" alt="" class="swiperLogoTag" />
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">巴塞罗那足球俱乐部</div>
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">帝纳波利交易大师</div>
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/s7bLogo4.svg" alt="" class="swiperLogoTag" />
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">40多年金融行业背景</div>
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/s7pLogo2.svg" alt="" class="swiperLogoTag" />
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">全球化团队1000+人</div>
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/s7bLogo2.svg" alt="" class="swiperLogoTag" />
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">英国FCA&澳大利亚ASIC</div>
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/s7pLogo1.svg" alt="" class="swiperLogoTag" />
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">开曼FCA&南非FSCA</div>
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">87.6%的订单优化率</div>
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/s7pLogo4.svg" alt="" class="swiperLogoTag" />
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">每秒聚合订单1000+</div>
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">平均执行速度20ms</div>
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/image/Affiliate/s7bLogo3.svg" alt="" class="swiperLogoTag" />
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">98.75%数据传输稳定性</div>
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">50+顶级流动性</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="aff-section8">
            <div class="contentBox">
                <h2>全球化团队为联盟赋能</h2>
                <div class="swiper section8Swiper">
                    <div class="swiper-wrapper techerList flex justify-between flex-wrap">
                        <div class="teacherCard swiper-slide">
                            <img src="@/assets/image/Affiliate/s8Bg1.jpg" class="lazyload" decoding="async" alt="" />
                            <div class="tag nameTag">乔尔.帝纳波利</div>
                            <div class="tag workTag">帝纳波利点位法创始人</div>
                        </div>
                        <div class="teacherCard swiper-slide">
                            <img src="@/assets/image/Affiliate/s8Bg2.jpg" class="lazyload" decoding="async" alt="" />
                            <div class="tag nameTag">Jason Zeng</div>
                            <div class="tag workTag">黄金率交易大师</div>
                        </div>
                        <div class="teacherCard swiper-slide">
                            <img src="@/assets/image/Affiliate/s8Bg3.jpg" class="lazyload" decoding="async" alt="" />
                            <div class="tag nameTag">Pieter van Wyk</div>
                            <div class="tag workTag">经济学家</div>
                        </div>
                        <div class="teacherCard swiper-slide">
                            <img src="@/assets/image/Affiliate/s8Bg4.jpg" class="lazyload" decoding="async" alt="" />'
                            <div class="tag nameTag">Coach Monchai</div>
                            <div class="tag workTag">泰国CMT协会主席</div>
                        </div>
                        <div class="teacherCard swiper-slide">
                            <img src="@/assets/image/Affiliate/s8Bg5.jpg" class="lazyload" decoding="async" alt="" />
                            <div class="tag nameTag">Coach Oy</div>
                            <div class="tag workTag">高级交易员</div>
                        </div>
                        <div class="teacherCard swiper-slide">
                            <img src="@/assets/image/Affiliate/s8Bg6.jpg" class="lazyload" decoding="async" alt="" />
                            <div class="tag nameTag">Jaime Marulanda</div>
                            <div class="tag workTag">算法交易专家</div>
                        </div>
                        <div class="teacherCard swiper-slide">
                            <img src="@/assets/image/Affiliate/s8Bg7.jpg" class="lazyload" decoding="async" alt="" />
                            <div class="tag nameTag">Tony Cao</div>
                            <div class="tag workTag">市场分析师</div>
                        </div>
                        <div class="teacherCard swiper-slide">
                            <img src="@/assets/image/Affiliate/s8Bg8.jpg" class="lazyload" decoding="async" alt="" />
                            <div class="tag nameTag">Precious David</div>
                            <div class="tag workTag">线下特邀讲师</div>
                        </div>
                        <div class="teacherCard swiper-slide">
                            <img src="@/assets/image/Affiliate/s8Bg9.jpg" class="lazyload" decoding="async" alt="" />
                            <div class="tag nameTag">Sergio Cisternas</div>
                            <div class="tag workTag">高级市场策略师</div>
                        </div>
                        <div class="teacherCard swiper-slide">
                            <img src="@/assets/image/Affiliate/s8Bg10.jpg" class="lazyload" decoding="async" alt="" />
                            <div class="tag nameTag">Karoll Olaya</div>
                            <div class="tag workTag">交易心理学专家</div>
                        </div>
                        <div class="teacherCard swiper-slide">
                            <img src="@/assets/image/Affiliate/s8Bg11.jpg" class="lazyload" decoding="async" alt="" />
                            <div class="tag nameTag">Bruna</div>
                            <div class="tag workTag">金融交易导师</div>
                        </div>
                        <div class="teacherCard swiper-slide">
                            <img src="@/assets/image/Affiliate/s8Bg12.jpg" class="lazyload" decoding="async" alt="" />
                            <div class="tag nameTag">Precious David</div>
                            <div class="tag workTag">交易策略专家</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="aff-section9">
            <div class="contentBox flex justify-between items-center">
                <div class="v-marquee s9Left">
                    <div class="v-col">
                        <div class="shadow topShadow"></div>
                        <div class="shadow bottomShadow"></div>
                        <div class="v-track v-track--left">
                            <img class="v-img lazyload" src="@/assets/image/Affiliate/s9limg1.png" decoding="async"
                                alt="" />
                            <img class="v-img lazyload" src="@/assets/image/Affiliate/s9limg2.png" decoding="async"
                                alt="" />
                            <img class="v-img lazyload" src="@/assets/image/Affiliate/s9limg3.png" decoding="async"
                                alt="" />
                            <img class="v-img lazyload" src="@/assets/image/Affiliate/s9limg1.png" decoding="async"
                                alt="" />
                            <img class="v-img lazyload" src="@/assets/image/Affiliate/s9limg2.png" decoding="async"
                                alt="" />
                            <img class="v-img lazyload" src="@/assets/image/Affiliate/s9limg3.png" decoding="async"
                                alt="" />
                        </div>
                    </div>

                    <div class="v-col v-col--offset">
                        <div class="shadow topShadow"></div>
                        <div class="shadow bottomShadow"></div>
                        <div class="v-track v-track--right">
                            <img class="v-img lazyload" src="@/assets/image/Affiliate/s9rimg1.png" decoding="async"
                                alt="" />
                            <img class="v-img lazyload" src="@/assets/image/Affiliate/s9rimg2.png" decoding="async"
                                alt="" />
                            <img class="v-img lazyload" src="@/assets/image/Affiliate/s9rimg3.png" decoding="async"
                                alt="" />
                            <img class="v-img lazyload" src="@/assets/image/Affiliate/s9rimg1.png" decoding="async"
                                alt="" />
                            <img class="v-img lazyload" src="@/assets/image/Affiliate/s9rimg2.png" decoding="async"
                                alt="" />
                            <img class="v-img lazyload" src="@/assets/image/Affiliate/s9rimg3.png" decoding="async"
                                alt="" />
                        </div>
                    </div>
                </div>
                <div class="s9Right">
                    <h2>与您并肩，共赴新程</h2>
                    <h3>EBC联盟计划由联盟经理、设计团队、自有客服团队、技术专家、金融行业专家、营销人员和运营人员共同运营，期待与您一起在全球市场中持续创造长期价值。</h3>
                    <a href="javascript:void(0);" class="primary-default_large">立即加入</a>
                </div>
                <div class="mobile">
                    <a href="javascript:void(0);" class="primary-default_large">立即加入</a>
                </div>
            </div>
        </div>
        <div class="aff-section10 container4 commonQuestion">
            <div class="contentBox">
                <h2>常见问题</h2>
                <div class="QA-list">
                    <div class="QA-item">
                        <div class="QA-title">
                            1. 如何成为EBC的联盟伙伴？
                        </div>
                        <div class="QA-content">
                            <p class="QA-li">
                                加入我们的联盟计划非常简单，请<a href="javascript:void(0);;"
                                    class="strongTag">点击此处</a>提交申请。如需了解更多关于我们联盟伙伴计划的信息，请发送电子邮件至： affiliate@ebc.com。
                            </p>
                        </div>
                    </div>
                    <div class="QA-item">
                        <div class="QA-title">
                            2. 如何获取推广链接？
                        </div>
                        <div class="QA-content">
                            <p class="QA-li">
                                登录您的联盟后，去到Referral link部分， 复制系统生成的专属链接。支持自定义格式，方便匹配不同推广渠道。
                            </p>
                        </div>
                    </div>
                    <div class="QA-item">
                        <div class="QA-title">
                            3. 如何下载推广素材（Creatives）？
                        </div>
                        <div class="QA-content">
                            <p class="QA-li">
                                登录联盟后台，在素材下载区即可获取横幅、海报、文案模板等资源。
                            </p>
                        </div>
                    </div>
                    <div class="QA-item">
                        <div class="QA-title">
                            4. 如何提取佣金？
                        </div>
                        <div class="QA-content">
                            <p class="QA-li">
                                请登录您的EBC Affiliate账号，在首页点击“Withdraw”按钮，即可提现。
                            </p>
                        </div>
                    </div>
                    <div class="QA-item">
                        <div class="QA-title">
                            5. 佣金是否实时支付？
                        </div>
                        <div class="QA-content">
                            <p class="QA-li">
                                您可以随时提现。如有任何与付款相关的问题，例如提款延迟等，请发送电子邮件至 funding@ebc.com 以便立即得到回复。
                            </p>
                        </div>
                    </div>
                    <div class="QA-item">
                        <div class="QA-title">
                            6. EBC支持哪些支付渠道？
                        </div>
                        <div class="QA-content">
                            <p class="QA-li">
                                支持银行卡、电子钱包、本地支付等多种方式。具体国家支持的付款渠道，请联系cs@ebc.com确认。
                            </p>
                        </div>
                    </div>
                    <div class="QA-item">
                        <div class="QA-title">
                            7. 是否有最低提现限额？
                        </div>
                        <div class="QA-content">
                            <p class="QA-li">
                                不同地区的单次提现最低金额不同。想了解最低提现金额，请联系：cs@ebc.com。不用担心，EBC Financial
                                Group始终尊重您的利益与需求。如果您的季度总收入未满足最低额度要求，您可以联系我们以协助您提取佣金。
                            </p>
                        </div>
                    </div>
                    <div class="QA-item">
                        <div class="QA-title">
                            8. 哪些国家/地区无法接收客户？
                        </div>
                        <div class="QA-content">
                            <p class="QA-li">
                                是的，我们可以为您提供 EBC 金融集团不接收客户的国家/地区列表。如果您想了解更多信息，请联系 cs@ebc.com。
                            </p>
                        </div>
                    </div>
                    <div class="QA-item">
                        <div class="QA-title">
                            9.EBC 是否可以扶持我的推广计划？
                        </div>
                        <div class="QA-content">
                            <p class="QA-li">
                                如果您有任何推广创意或合作计划，欢迎随时联系我们：affiliate@ebc.com，EBC将尽力提供必要的资源与支持。
                            </p>
                        </div>
                    </div>
                    <div class="QA-item">
                        <div class="QA-title">
                            10.在开始推广前，我需要注意哪些事项？是否有不被允许的推广行为？
                        </div>
                        <div class="QA-content">
                            <p class="QA-li">
                                在开始推广前，请您务必仔细阅读并遵循我们的 <span
                                    class="guideDial cursor-pointer">《联盟营销指南》</span>，以确保您的推广行为符合平台及合规要求，并持续保留您的联盟资格。
                                如发生违反营销指南或不当推广行为的情况，我们有权根据实际情况暂停或终止合作。
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pageDial">
            <img class="closeTag cursor-pointer" src="@/assets/image/Affiliate/closeTag.svg" />
            <div class="title-32_bold">营销指南</div>
            <div class="contentContainer">
                <div class="title subtitle-18_medium">1.应避免的营销声明和陈述</div>
                <div class="desc subtitle-18_regular">请勿在任何广告或营销材料中使用以下内容。</div>
                <div class="desc subtitle-18_regular">不要做出任何关于客户投资者几乎没有或完全没有亏损风险的声明或断言。不要做出任何可能无法兑现的承诺，例如任何好处。</div>
                <div class="desc subtitle-18_regular">
                    请勿提供任何误导性信息、重大虚假或不实陈述或声明，以吸引或说服他人申请开户。如果您不确定该如何措辞，请立即联系我们，我们将竭诚为您提供帮助。</div>
                <div class="desc subtitle-18_regular">不要擅自使用巴塞罗那足球俱乐部相关的物料</div>
                <div class="title subtitle-18_medium">2.禁止的营销行为</div>
                <div class="desc subtitle-18_regular">您不得从事任何非法、不正当、误导性或欺骗性行为，也不得做出任何可能对我们的声誉或我们的产品和服务声誉造成不利影响的陈述。</div>
                <div class="desc subtitle-18_regular">您不得从事任何类型的非法活动，例如在您的网站或订阅邮件中展示非法内容。</div>
                <div class="desc subtitle-18_regular">您不得主动针对以下人群：任何未满 18 周岁的人士；以及已通知您禁止注册交易员的其他国家/地区的人士。</div>
                <div class="desc subtitle-18_regular">登录交易员账户或代表他们进行交易活动。</div>
                <div class="desc subtitle-18_regular">
                    运营包含或推广误导性、诽谤性或非法内容的网站，或提供指向此类网站的链接。误导性内容包括就退货做出任何承诺，以及未经我们明确许可展示我们的免责声明和许可协议。</div>
                <div class="desc subtitle-18_regular">发送未经请求的商业电子信息（垃圾邮件）。</div>
                <div class="desc subtitle-18_regular">
                    通过您在商业电子信息、展示广告网络、计数器、留言簿、论坛、博客、聊天室或其他类似互联网资源中提供的指向我们网站的推荐链接，将潜在交易者直接引导至我们的网站。</div>
                <div class="desc subtitle-18_regular">允许进行恶意交易，包括通过任何设备、程序、机器人、IP 地址、重定向和“虚假”流量。</div>
                <div class="desc subtitle-18_regular">未经我们事先批准，不得设立任何向注册账户的交易者提供奖励、积分或补偿的促销活动，包括任何形式的付款交易。</div>
                <div class="desc subtitle-18_regular">采取任何会削弱或损害我们商标或品牌价值的行为。</div>
                <div class="desc subtitle-18_regular">使用盗窃的信用卡生成。</div>
                <div class="desc subtitle-18_regular">由媒体公司的分销合作伙伴恶意手动创建，其直接目的是人为地提高应付给分销合作伙伴的佣金。</div>
                <div class="desc subtitle-18_regular">来自同一设备或 IP 地址的多次注册将不计入。EBC 金融集团风险控制团队将审核用户资质。</div>
                <div class="title subtitle-18_medium">3.知识产权</div>
                <div class="desc subtitle-18_regular">
                    您承认，我们将保留在本条款有效期之前或期间开发的所有材料（包括合作伙伴宣传材料）的所有权利（包括知识产权）。除本条款允许的情况外，本条款中的任何内容均不应被解释为授予您使用合作伙伴宣传材料或我们任何其他商标和品牌标识的任何许可或权利。
                </div>
                <div class="desc subtitle-18_regular">如果您符合以下条件，则可以在您的网站上展示横幅广告和文字链接，使用其他合作伙伴的宣传材料，并以“EBC Financial
                    Group 联盟会员”的身份开展本联盟计划下的推荐活动：</div>
                <div class="desc subtitle-18_regular">在发布任何合作伙伴宣传材料之前，请先获得我们的批准（我们不会无故拒绝批准）；请勿将合作伙伴宣传材料用作您自己的产品名称、URL
                    或作为其他徽标的组成部分；并且请以符合我们的品牌指南和我们不时向您提供的任何其他指示的方式展示合作伙伴宣传材料。</div>
                <div class="desc subtitle-18_regular">
                    如果您发现我们的任何知识产权或其他所有权受到侵犯，或者如果您发现任何一方声称我们的产品、商标或标识侵犯了第三方的知识产权或所有权，您应立即以书面形式通知我们。</div>
                <div class="desc subtitle-18_regular">如果您违反这些规定，我们保留终止您会员资格并取消您应得的任何费用的权利。</div>

            </div>
        </div>
        <div class="affApplyDial" role="dialog" aria-modal="true" aria-hidden="true" data-join-sep="、" data-lang="zh">
            <div class="affApplyHeader">
                <div class="affApplyTitle">提交合作申请</div>
                <button type="button" class="affApplyClose" aria-label="close">&times;</button>
            </div>

            <form class="affApplyForm" autocomplete="off" novalidate>
                <div class="affApplyField" data-aff-field="entityType" data-aff-type="single">
                    <div class="affApplyLabelRow affApplyHint">
                        <span class="affApplyLabel">主体类型</span>
                        <span class="affApplyHint">(主体类型将用于后续身份认证。个人需完成 KYC，机构需完成 KYB。)</span>
                    </div>
                    <div class="affApplyControl affApplySelect" data-aff-control="entityType" tabindex="0">
                        <div class="affApplySelectValue" data-aff-value="entityType"></div>
                        <div class="affApplyArrow"></div>
                    </div>
                    <div class="affApplyDropdown" data-aff-dropdown="entityType">
                        <div class="affApplyOption" data-aff-option="entityType" data-key="individual">
                            <span>个人</span><span class="affApplyCheck"></span>
                        </div>
                        <div class="affApplyOption" data-aff-option="entityType" data-key="company">
                            <span>机构</span><span class="affApplyCheck"></span>
                        </div>
                    </div>
                </div>

                <div class="affApplyGrid">
                    <div class="affApplyField" data-aff-field="name" data-aff-type="input">
                        <div class="affApplyLabelRow">
                            <span class="affApplyLabel">联系人称呼</span><span class="affApplyLabel">*</span>
                        </div>
                        <div class="affApplyControl" data-aff-control="name">
                            <input class="affApplyInput" data-aff-input="name" placeholder="请填写你的姓名或常用称呼" />
                        </div>
                    </div>

                    <div class="affApplyField" data-aff-field="country" data-aff-type="single">
                        <div class="affApplyLabelRow">
                            <span class="affApplyLabel">所在国家 / 地区</span><span class="affApplyLabel">*</span>
                        </div>
                        <div class="affApplyControl affApplySelect" data-aff-control="country" tabindex="0">
                            <div class="affApplySelectValue is-placeholder" data-aff-value="country"
                                data-placeholder="请选择">请选择</div>
                            <div class="affApplyArrow"></div>
                        </div>
                        <div class="affApplyDropdown" data-aff-dropdown="country"></div>
                    </div>

                    <div class="affApplyField" data-aff-field="email" data-aff-type="input">
                        <div class="affApplyLabelRow">
                            <span class="affApplyLabel">联系邮箱</span><span class="affApplyLabel">*</span>
                        </div>
                        <div class="affApplyControl" data-aff-control="email">
                            <input class="affApplyInput" data-aff-input="email" placeholder="请输入您的邮箱地址" />
                        </div>
                        <div class="affApplyError" data-aff-error="email">请检查邮箱格式</div>
                    </div>

                    <div class="affApplyField" data-aff-field="phone" data-aff-type="input">
                        <div class="affApplyLabelRow">
                            <span class="affApplyLabel">联系电话</span><span class="affApplyLabel">*</span>
                        </div>
                        <div class="affApplyControl" data-aff-control="phone">
                            <input class="affApplyInput" data-aff-input="phone" placeholder="建议填写常用手机号，便于审核沟通" />
                        </div>
                    </div>

                    <div class="affApplyField" data-aff-field="regions" data-aff-type="multi">
                        <div class="affApplyLabelRow">
                            <span class="affApplyLabel">预计推广地区</span><span class="affApplyLabel">*</span>
                        </div>
                        <div class="affApplyControl affApplySelect" data-aff-control="regions" tabindex="0">
                            <div class="affApplySelectValue is-placeholder" data-aff-value="regions"
                                data-placeholder="请选择">请选择</div>
                            <div class="affApplyArrow"></div>
                        </div>
                        <div class="affApplyDropdown" data-aff-dropdown="regions"></div>
                    </div>

                    <div class="affApplyField" data-aff-field="channels" data-aff-type="multi">
                        <div class="affApplyLabelRow">
                            <span class="affApplyLabel">主要推广渠道</span><span class="affApplyLabel">*</span>
                        </div>
                        <div class="affApplyControl affApplySelect" data-aff-control="channels" tabindex="0">
                            <div class="affApplySelectValue is-placeholder" data-aff-value="channels"
                                data-placeholder="请选择">请选择</div>
                            <div class="affApplyArrow"></div>
                        </div>
                        <div class="affApplyDropdown" data-aff-dropdown="channels">
                            <div class="affApplyOption" data-aff-option="channels" data-key="website_blog"><span>网站 /
                                    Blog</span><span class="affApplyCheck"></span></div>
                            <div class="affApplyOption" data-aff-option="channels" data-key="email_marketing">
                                <span>邮件营销</span><span class="affApplyCheck"></span></div>
                            <div class="affApplyOption" data-aff-option="channels" data-key="offline_resources">
                                <span>线下资源</span><span class="affApplyCheck"></span></div>
                            <div class="affApplyOption" data-aff-option="channels" data-key="community_private"><span>社群
                                    / 私域</span><span class="affApplyCheck"></span></div>
                            <div class="affApplyOption" data-aff-option="channels" data-key="video_livestream"><span>视频
                                    / 直播</span><span class="affApplyCheck"></span></div>
                            <div class="affApplyOption" data-aff-option="channels" data-key="social_media">
                                <span>社交媒体</span><span class="affApplyCheck"></span></div>
                            <div class="affApplyOption" data-aff-option="channels" data-key="other"><span>其他</span><span
                                    class="affApplyCheck"></span></div>
                        </div>
                    </div>
                </div>

                <div class="affApplyActions">
                    <button type="button" class="affApplyBtn affApplyBtn--ghost affApplyCancel">取消</button>
                    <button type="submit" class="affApplyBtn affApplyBtn--primary affApplyConfirm" disabled>提交</button>
                </div>
            </form>
        </div>
        <page-footer></page-footer>
    </div>
</template>
<script>
import geoJson from '@/assets/js/worldData.json'
import * as echarts from 'echarts'

import fadeAnimate from "../mixins/fadeAnimate.js";
import { mapGetters } from 'vuex';
import 'swiper/css/swiper.css'
import Swiper from 'swiper'
export default {
    mixins: [fadeAnimate],
    data() {
        return {

        }
    },
    mounted() {
        this.initPage();
        this.initForm();
    },
    methods: {
        initForm() {
            // Affiliate Apply Modal (open by clicking links in aff-section1/2/9)
            (function initAffiliateApplyModal() {
                const pageShadowEl = document.querySelector(".pageShadow");
                const dialEl = document.querySelector(".affApplyDial");
                if (!pageShadowEl || !dialEl) return;

                const formEl = dialEl.querySelector(".affApplyForm");
                const closeBtn = dialEl.querySelector(".affApplyClose");
                const cancelBtn = dialEl.querySelector(".affApplyCancel");
                const confirmBtn = dialEl.querySelector(".affApplyConfirm");
                if (!formEl || !closeBtn || !cancelBtn || !confirmBtn) return;

                const joinSep = dialEl.getAttribute("data-join-sep") || ", ";

                function getOptionEls(field) {
                    return Array.from(
                        dialEl.querySelectorAll(`.affApplyOption[data-aff-option="${field}"][data-key]`)
                    );
                }
                function getFirstKey(field) {
                    return getOptionEls(field)[0]?.getAttribute("data-key") || "";
                }
                function getLabelByKey(field, key) {
                    if (!key) return "";
                    const el = getOptionEls(field).find((n) => n.getAttribute("data-key") === key);
                    return (el?.querySelector("span")?.textContent || "").trim();
                }
                function getPlaceholder(field) {
                    const valueEl = dialEl.querySelector(`[data-aff-value="${field}"]`);
                    return valueEl?.getAttribute("data-placeholder") || "";
                }

                let messageWrapEl = null;

                function showAffMessage(msg, type) {
                    const dataV = getDataVAttribute(document.querySelector('.aff-section1'))
                    const text = String(msg || "").trim();
                    if (!text) return;

                    if (!messageWrapEl) {
                        messageWrapEl = document.querySelector(".affMessageWrap");
                        if (!messageWrapEl) {
                            messageWrapEl = document.createElement("div");
                            messageWrapEl.className = "affMessageWrap";
                            messageWrapEl.setAttribute(dataV,'')
                            document.body.appendChild(messageWrapEl);
                        }
                    }
                    const el = document.createElement("div");
                    el.className = `affMessage ${type ? `is-${type}` : ""}`;
                    el.textContent = text;
                    el.setAttribute(dataV,'')

                    messageWrapEl.appendChild(el);

                    requestAnimationFrame(() => el.classList.add("show"));

                    window.setTimeout(() => {
                        el.classList.remove("show");
                        window.setTimeout(() => {
                            try {
                                el.remove();
                            } catch (e) { }
                        }, 220);
                    }, 2600);
                }
                const state = {
                    href: "",
                    target: "_self",
                    attempted: false,
                    emailTouched: false,
                    entityType: getFirstKey("entityType"),
                    name: "",
                    country: "",
                    email: "",
                    phone: "",
                    regions: [],
                    channels: [],
                };

                function getOpenDialogsCount() {
                    const guideOpen = !!document.querySelector(".pageDial.showDial");
                    const applyOpen = dialEl.classList.contains("showDial");
                    return Number(guideOpen) + Number(applyOpen);
                }

                function syncShadow() {
                    if (getOpenDialogsCount() > 0) pageShadowEl.classList.add("showShadow");
                    else pageShadowEl.classList.remove("showShadow");
                }

                function closeAllDropdowns() {
                    dialEl.querySelectorAll(".affApplyField.is-open").forEach((el) => {
                        el.classList.remove("is-open");
                        el.classList.remove("open-up");
                        const dd = el.querySelector(".affApplyDropdown");
                        if (dd) dd.style.maxHeight = "";
                    });
                }

                let geoListLoaded = false;
                let geoListLoading = false;
                function getDataVAttribute(element) {
                // 1. 统一转换为原生 HTMLElement
                const el = element?.value || (typeof element === 'string' ? document.querySelector(element) : element);

                if (!el) {
                    console.warn('【getDataV】未找到指定的元素');
                    return null;
                }

                // 2. 遍历属性寻找以 "data-v-" 开头的属性名
                const attributes = el.attributes;
                for (let i = 0; i < attributes.length; i++) {
                    const attrName = attributes[i].name;
                    if (attrName.startsWith('data-v-')) {
                    return attrName; // 找到后直接返回属性名
                    }
                }

                return null; // 没找到返回 null
                }
                async function loadGeoList() {
                    if (geoListLoaded || geoListLoading) return;
                    geoListLoading = true;
                    const countryDropdown = dialEl.querySelector('[data-aff-dropdown="country"]');
                    const regionsDropdown = dialEl.querySelector('[data-aff-dropdown="regions"]');
                    if (!countryDropdown && !regionsDropdown) {
                        geoListLoading = false;
                        return;
                    }
                    const dataV =  getDataVAttribute(countryDropdown)
                    const lang =
                        dialEl.getAttribute("data-lang") ||
                        (document.documentElement.getAttribute("lang") || "en").split("-")[0];
                    const url = `https://s.ebcjpn.com/api/register/countries?language=${encodeURIComponent(
                        lang
                    )}`;

                    try {
                        const res = await fetch(url, { method: "GET" });
                        const json = await res.json();
                        const list = Array.isArray(json?.data) ? json.data : [];
                        const html = list
                            .map((it) => {
                                const key = String(it?.oriKey ?? "").trim();
                                const name = String(it?.countryName ?? "").trim();
                                if (!key || !name) return "";
                                // country: single, regions: multi (share same data list)
                                return `<div class="affApplyOption" ${dataV} data-aff-option="__FIELD__" data-key="${key}"><span>${name}</span><span class="affApplyCheck" ${dataV}></span></div>`;
                            })
                            .filter(Boolean)
                            .join("");
                        if (countryDropdown) {
                            countryDropdown.innerHTML = html.replaceAll("__FIELD__", "country");
                        }
                        if (regionsDropdown) {
                            regionsDropdown.innerHTML = html.replaceAll("__FIELD__", "regions");
                        }
                        geoListLoaded = true;
                        syncOptionsSelected("country");
                        syncOptionsSelected("regions");
                        renderAll();
                    } catch (err) {
                        // keep dropdown empty on failure
                    } finally {
                        geoListLoading = false;
                    }
                }

                function adjustDropdownLayout(field) {
                    const fieldEl = dialEl.querySelector(`[data-aff-field="${field}"]`);
                    if (!fieldEl) return;
                    const dropdown = fieldEl.querySelector(".affApplyDropdown");
                    const control = fieldEl.querySelector(`[data-aff-control="${field}"]`);
                    if (!dropdown || !control) return;

                    const isMobile = window.matchMedia("(max-width: 996px)").matches;
                    if (!isMobile) return;

                    const modalRect = dialEl.getBoundingClientRect();
                    const controlRect = control.getBoundingClientRect();
                    const headerRect =
                        dialEl.querySelector(".affApplyHeader")?.getBoundingClientRect() || null;
                    const safeTop = headerRect ? headerRect.bottom : modalRect.top;

                    const padding = 16;
                    const spaceBelow = modalRect.bottom - controlRect.bottom - padding;
                    const spaceAbove = controlRect.top - safeTop - padding;

                    const openUp = spaceBelow < 180 && spaceAbove > spaceBelow;
                    fieldEl.classList.toggle("open-up", openUp);

                    const maxH = Math.max(120, openUp ? spaceAbove : spaceBelow);
                    dropdown.style.maxHeight = `${Math.floor(maxH)}px`;
                }

                function openModal({ href, target }) {
                    // Close guide dialog if open (avoid stacking)
                    const guideDialog = document.querySelector(".pageDial");
                    if (guideDialog && guideDialog.classList.contains("showDial")) {
                        guideDialog.classList.remove("showDial");
                    }

                    state.href = href || "";
                    state.target = target ? target : "_self";
                    state.attempted = false;
                    state.emailTouched = false;

                    // Preload geo list (country + regions) on open
                    loadGeoList();

                    // Reset form values on each open (keep entity default)
                    state.entityType = getFirstKey("entityType");
                    state.name = "";
                    state.country = "";
                    state.email = "";
                    state.phone = "";
                    state.regions = [];
                    state.channels = [];

                    dialEl.classList.add("showDial");
                    dialEl.setAttribute("aria-hidden", "false");
                    syncShadow();
                    closeAllDropdowns();
                    renderAll();

                    const nameInput = dialEl.querySelector('[data-aff-input="name"]');
                    nameInput && nameInput.focus();
                }

                function closeModal() {
                    dialEl.classList.remove("showDial");
                    dialEl.setAttribute("aria-hidden", "true");
                    closeAllDropdowns();
                    syncShadow();
                }

                function isEmailValid(v) {
                    const s = String(v || "").trim();
                    if (!s) return false;
                    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);
                }

                function isFormReady() {
                    return (
                        String(state.name || "").trim() &&
                        String(state.country || "").trim() &&
                        String(state.email || "").trim() &&
                        String(state.phone || "").trim() &&
                        Array.isArray(state.regions) &&
                        state.regions.length > 0 &&
                        Array.isArray(state.channels) &&
                        state.channels.length > 0
                    );
                }

                function isFormValid() {
                    return (
                        String(state.name || "").trim() &&
                        String(state.country || "").trim() &&
                        isEmailValid(state.email) &&
                        String(state.phone || "").trim() &&
                        Array.isArray(state.regions) &&
                        state.regions.length > 0 &&
                        Array.isArray(state.channels) &&
                        state.channels.length > 0
                    );
                }

                function setControlError(field, hasError) {
                    const control = dialEl.querySelector(`[data-aff-control="${field}"]`);
                    if (!control) return;
                    control.classList.toggle("is-error", !!hasError);
                }

                function setFieldError(field, hasError) {
                    const fieldEl = dialEl.querySelector(`[data-aff-field="${field}"]`);
                    if (!fieldEl) return;
                    fieldEl.classList.toggle("has-error", !!hasError);
                }

                function validateAll() {
                    const attempted = state.attempted;
                    // Required field borders (only show after attempted)
                    setControlError("name", attempted && !String(state.name || "").trim());
                    setControlError("country", attempted && !String(state.country || "").trim());
                    setControlError("phone", attempted && !String(state.phone || "").trim());
                    setControlError("regions", attempted && !(state.regions && state.regions.length));
                    setControlError("channels", attempted && !(state.channels && state.channels.length));

                    // Email:
                    // - Grey button (not ready): do not show format error
                    // - Red button (ready) and click confirm: show format error if invalid
                    const emailEmpty = !String(state.email || "").trim();
                    const shouldShowFormatError = attempted && isFormReady() && !isEmailValid(state.email);
                    const shouldShowRequiredBorder = attempted && emailEmpty;

                    setControlError("email", shouldShowRequiredBorder || shouldShowFormatError);
                    setFieldError("email", shouldShowFormatError);
                }

                function setValueText(field, text, isPlaceholder) {
                    const valueEl = dialEl.querySelector(`[data-aff-value="${field}"]`);
                    if (!valueEl) return;
                    valueEl.textContent = text;
                    valueEl.classList.toggle("is-placeholder", !!isPlaceholder);
                }

                function joinMulti(values) {
                    const arr = Array.isArray(values) ? values : [];
                    return arr.join(joinSep);
                }

                function updateConfirmState() {
                    confirmBtn.disabled = !isFormReady();
                }

                function syncOptionsSelected(field) {
                    const type = dialEl
                        .querySelector(`[data-aff-field="${field}"]`)
                        ?.getAttribute("data-aff-type");
                    const selectedSet =
                        type === "multi" ? new Set(state[field] || []) : new Set([state[field]]);
                    getOptionEls(field).forEach((el) => {
                        const key = el.getAttribute("data-key");
                        el.classList.toggle("is-selected", selectedSet.has(key));
                    });
                }

                function renderAll() {
                    const entityLabel = getLabelByKey("entityType", state.entityType) || getLabelByKey("entityType", getFirstKey("entityType"));
                    setValueText("entityType", entityLabel, false);

                    const countryLabel = getLabelByKey("country", state.country);
                    setValueText(
                        "country",
                        countryLabel ? countryLabel : getPlaceholder("country"),
                        !countryLabel
                    );

                    const regionsLabels = (state.regions || [])
                        .map((k) => getLabelByKey("regions", k))
                        .filter(Boolean);
                    setValueText(
                        "regions",
                        regionsLabels.length ? joinMulti(regionsLabels) : getPlaceholder("regions"),
                        !regionsLabels.length
                    );

                    const channelLabels = (state.channels || [])
                        .map((k) => getLabelByKey("channels", k))
                        .filter(Boolean);
                    setValueText(
                        "channels",
                        channelLabels.length ? joinMulti(channelLabels) : getPlaceholder("channels"),
                        !channelLabels.length
                    );

                    dialEl.querySelector('[data-aff-input="name"]').value = state.name || "";
                    dialEl.querySelector('[data-aff-input="email"]').value = state.email || "";
                    dialEl.querySelector('[data-aff-input="phone"]').value = state.phone || "";

                    syncOptionsSelected("entityType");
                    syncOptionsSelected("country");
                    syncOptionsSelected("regions");
                    syncOptionsSelected("channels");

                    validateAll();
                    updateConfirmState();
                }

                function toggleDropdown(field) {
                    const fieldEl = dialEl.querySelector(`[data-aff-field="${field}"]`);
                    if (!fieldEl) return;
                    const willOpen = !fieldEl.classList.contains("is-open");
                    closeAllDropdowns();
                    if (willOpen) fieldEl.classList.add("is-open");
                    if (willOpen) {
                        if (field === "country" || field === "regions") {
                            loadGeoList().finally(() => {
                                adjustDropdownLayout(field);
                            });
                        } else {
                            adjustDropdownLayout(field);
                        }
                    }
                }

                function onPickOption(field, key) {
                    const type = dialEl.querySelector(`[data-aff-field="${field}"]`)?.getAttribute("data-aff-type");
                    if (type === "multi") {
                        const set = new Set(state[field] || []);
                        if (set.has(key)) set.delete(key);
                        else set.add(key);
                        state[field] = Array.from(set);
                    } else {
                        state[field] = key;
                        closeAllDropdowns();
                    }
                    renderAll();
                }

                // Populate initial UI once
                state.entityType = state.entityType || getFirstKey("entityType");
                renderAll();

                // Link clicks in sections -> open modal
                document.addEventListener("click", (e) => {
                    const a = e.target.closest(".aff-section1 a, .aff-section5 a, .aff-section9 a,.strongTag");
                    if (!a) return;
                    const href = a.getAttribute("href");
                    if (!href) return;
                    e.preventDefault();
                    openModal({ href, target: a.getAttribute("target") });
                });

                // Open/close dropdowns & pick options
                dialEl.addEventListener("click", (e) => {
                    const optionEl = e.target.closest("[data-aff-option]");
                    if (optionEl) {
                        const field = optionEl.getAttribute("data-aff-option");
                        const key = optionEl.getAttribute("data-key");
                        if (field && key) onPickOption(field, key);
                        return;
                    }

                    const controlEl = e.target.closest("[data-aff-control]");
                    if (controlEl) {
                        const field = controlEl.getAttribute("data-aff-control");
                        const type = dialEl.querySelector(`[data-aff-field="${field}"]`)?.getAttribute("data-aff-type");
                        if (type === "single" || type === "multi") {
                            toggleDropdown(field);
                        }
                        return;
                    }
                });

                // Close dropdown when clicking outside of it (but inside the dialog)
                dialEl.addEventListener("mousedown", (e) => {
                    const inDropdown = e.target.closest(".affApplyDropdown");
                    const inControl = e.target.closest(".affApplyControl");
                    if (!inDropdown && !inControl) closeAllDropdowns();
                });

                // Inputs
                dialEl.querySelectorAll("[data-aff-input]").forEach((input) => {
                    input.addEventListener("input", (e) => {
                        const field = e.target.getAttribute("data-aff-input");
                        state[field] = e.target.value;
                        renderAll();
                    });
                    input.addEventListener("blur", (e) => {
                        const field = e.target.getAttribute("data-aff-input");
                        if (field === "email") {
                            // Keep this flag for potential future UX, but don't show format error here.
                            state.emailTouched = true;
                        }
                    });
                });

                // Close
                closeBtn.addEventListener("click", closeModal);
                cancelBtn.addEventListener("click", closeModal);
                pageShadowEl.addEventListener("click", () => {
                    if (dialEl.classList.contains("showDial")) closeModal();
                });
                document.addEventListener("keydown", (e) => {
                    if (e.key === "Escape" && dialEl.classList.contains("showDial")) closeModal();
                });
            
                let successMsg = '提交成功'
                // Submit
                formEl.addEventListener("submit", (e) => {
                    e.preventDefault();
                    // If confirm is grey (disabled), do nothing (incl. don't validate email)
                    if (confirmBtn.disabled) return;

                    state.attempted = true;
                    validateAll();
                    updateConfirmState();

                    if (!isFormValid()) return;

                    (async () => {
                        const endpoint = "https://www.ebccfd.com/portal/Contact/affiliateSubmit";

                        const locationLabel = getLabelByKey("country", state.country);
                        const entityLabel = getLabelByKey("entityType", state.entityType);

                        const regionsLabels = (state.regions || [])
                            .map((k) => getLabelByKey("regions", k))
                            .filter(Boolean);

                        const channelLabels = (state.channels || [])
                            .map((k) => getLabelByKey("channels", k))
                            .filter(Boolean);

                        const payload = {
                            name: String(state.name || "").trim(),
                            phone: String(state.phone || "").trim(),
                            email: String(state.email || "").trim(),
                            ...(locationLabel ? { location: locationLabel } : {}),
                            ...(entityLabel ? { entityType: entityLabel } : {}),
                            ...(regionsLabels.length ? { promoRegions: regionsLabels } : {}),
                            ...(channelLabels.length ? { promoChannels: channelLabels } : {}),
                        };

                        confirmBtn.disabled = true;
                        confirmBtn.classList.add("is-loading");

                        try {
                            const res = await fetch(endpoint, {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json;charset=UTF-8",
                                },
                                body: JSON.stringify(payload),
                            });
                            const json = await res.json().catch(() => null);
                            const ok = json && Number(json.code) === 1;
                            const msg = successMsg;
                            showAffMessage(msg, ok ? "success" : "error");

                            if (ok) {
                                setTimeout(() => {
                                    closeModal();
                                }, 800);
                            } else {
                                // allow retry
                                confirmBtn.disabled = !isFormReady();
                            }
                        } catch (err) {
                            const fallback = "提交失败，请稍后再试";
                            showAffMessage(fallback, "error");
                            confirmBtn.disabled = !isFormReady();
                        } finally {
                            confirmBtn.classList.remove("is-loading");
                        }
                    })();
                });
            })();
        },
        async initPage() {

            await new Promise(res => {
                setTimeout(res)
            })
            const isMobile = window.matchMedia("(max-width:996px)").matches;
            // 配置参数
            const maxPeople = 300;
            const maxCommission = 200000;
            const svgViewBox = { width: 1137, height: 337 };

            // SVG路径数据 - 使用提供的精确路径（整体上移30px）
            const pathData = "M0 306.388C180.763 306.388 803.601 239.758 1136 -29.611511";

            // 1人的起始X坐标，距离曲线起点50px
            // 300人的结束X坐标，距离曲线终点60px（30+30）
            const peopleStartX = 50;
            const peopleEndX = 1076; // 1136 - 60

            // 创建路径对象用于计算
            let pathElement = null;
            let pathLength = 0;

            // 根据人数计算佣金的函数
            function calculateCommission(people) {
                return people * 730;
            }

            // 格式化金额
            function formatCurrency(amount) {
                return "$" + amount.toLocaleString("en-US");
            }

            // 根据人数获取路径上的精确点（使用二分搜索优化性能）
            function getPointOnPath(people) {
                if (!pathElement) return { x: peopleStartX, y: 306.388 };

                // 将人数映射到X坐标范围 [peopleStartX, peopleEndX]
                const targetX =
                    peopleStartX +
                    ((people - 1) / (maxPeople - 1)) * (peopleEndX - peopleStartX);

                // 使用二分搜索在路径上找到对应X坐标的点
                let left = 0;
                let right = pathLength;
                let bestPoint = { x: peopleStartX, y: 306.388 };

                while (right - left > 0.5) {
                    const mid = (left + right) / 2;
                    const point = pathElement.getPointAtLength(mid);

                    if (point.x < targetX) {
                        left = mid;
                    } else {
                        right = mid;
                    }
                }

                bestPoint = pathElement.getPointAtLength(left);
                return bestPoint;
            }

            // 根据X坐标反推对应的人数
            function getPeopleFromX(targetX) {
                if (!pathElement) return 1;

                // 如果点击位置在起始范围之前，返回1人
                if (targetX <= peopleStartX) return 1;

                // 如果点击位置超出结束范围，返回最大人数
                if (targetX >= peopleEndX) return maxPeople;

                // 线性映射：从X坐标范围反推人数
                const ratio = (targetX - peopleStartX) / (peopleEndX - peopleStartX);
                const people = Math.round(1 + ratio * (maxPeople - 1));

                return Math.max(1, Math.min(maxPeople, people));
            }

            // 更新图表
            function updateChart(people) {
                currentPeople = people;
                const commission = calculateCommission(people);

                // 更新佣金显示
                document.getElementById("commissionAmount").textContent =
                    formatCurrency(commission);

                // 获取当前点的位置
                const point = getPointOnPath(people);

                // 计算目标X坐标
                const targetX =
                    peopleStartX +
                    ((people - 1) / (maxPeople - 1)) * (peopleEndX - peopleStartX);

                // 使用二分搜索在路径上找到对应的长度（优化性能）
                let left = 0;
                let right = pathLength;
                let currentLength = 0;

                while (right - left > 0.5) {
                    const mid = (left + right) / 2;
                    const p = pathElement.getPointAtLength(mid);

                    if (p.x < targetX) {
                        left = mid;
                    } else {
                        right = mid;
                    }
                }
                currentLength = left;

                // 更新激活路径的显示长度（使用stroke-dasharray）
                const activePath = document.getElementById("activePath");
                // stroke-dasharray: 显示的长度, 隐藏的长度
                activePath.setAttribute("stroke-dasharray", `${currentLength} ${pathLength}`);

                // 更新标记点
                updateMarker(point, people);
            }

            // 更新标记点
            function updateMarker(point, people) {
                const chartContainer = document.getElementById("chartContainer");
                const chartSvg = document.getElementById("chartSvg");
                const svgRect = chartSvg.getBoundingClientRect();
                const containerRect = chartContainer.getBoundingClientRect();

                // SVG viewBox 到实际显示的映射
                const scaleX = svgRect.width / svgViewBox.width;
                const scaleY = svgRect.height / svgViewBox.height;

                // 计算在SVG中的实际像素位置
                const svgPixelX = point.x * scaleX;
                const svgPixelY = point.y * scaleY;

                // 转换为相对于容器的位置
                const actualX = svgPixelX + (svgRect.left - containerRect.left);
                const actualY = svgPixelY + (svgRect.top - containerRect.top);

                // 移除旧的标记
                const oldBadge = document.querySelector(".point-badge");
                const oldDot = document.querySelector(".point-dot");
                if (oldBadge) oldBadge.remove();
                if (oldDot) oldDot.remove();

                // 创建新标记
                const badge = document.createElement("div");
                badge.className = "point-badge";
                badge.textContent = `${people}人`;
                badge.style.left = actualX + "px";
                badge.style.top = actualY + "px";

                const dot = document.createElement("div");
                dot.className = "point-dot";
                dot.style.left = actualX + "px";
                dot.style.top = actualY + "px";

                chartContainer.appendChild(badge);
                chartContainer.appendChild(dot);
            }

            // 拖拽状态
            let isDragging = false;
            let hasDragged = false;
            let currentPeople = 150;

            // 处理位置更新
            function handlePositionUpdate(clientX) {
                const chartSvg = document.getElementById("chartSvg");
                const svgRect = chartSvg.getBoundingClientRect();

                // 获取鼠标在SVG中的相对位置
                const mouseX = clientX - svgRect.left;

                // 转换为SVG viewBox坐标
                const svgX = (mouseX / svgRect.width) * svgViewBox.width;

                // 限制在有效范围内
                const clampedX = Math.max(0, Math.min(svgViewBox.width, svgX));

                // 计算对应的人数
                const people = getPeopleFromX(clampedX);

                // 更新图表
                updateChart(people);
            }

            // 鼠标按下事件
            function handleMouseDown(event) {
                // 检查是否点击在点或标签上
                const dot = document.querySelector(".point-dot");
                const badge = document.querySelector(".point-badge");
                if (!dot) return;

                const clickX = event.clientX;
                const clickY = event.clientY;

                // 检查是否点击在点上
                const dotRect = dot.getBoundingClientRect();
                const padding = 10;
                const clickedDot =
                    clickX >= dotRect.left - padding &&
                    clickX <= dotRect.right + padding &&
                    clickY >= dotRect.top - padding &&
                    clickY <= dotRect.bottom + padding;

                // 检查是否点击在标签上
                let clickedBadge = false;
                if (badge) {
                    const badgeRect = badge.getBoundingClientRect();
                    clickedBadge =
                        clickX >= badgeRect.left &&
                        clickX <= badgeRect.right &&
                        clickY >= badgeRect.top &&
                        clickY <= badgeRect.bottom;
                }

                if (clickedDot || clickedBadge) {
                    isDragging = true;
                    hasDragged = false;
                    document.getElementById("chartContainer").classList.add("dragging");
                    if (badge) badge.style.cursor = "grabbing";
                    event.preventDefault();
                }
            }

            // 鼠标移动事件
            function handleMouseMove(event) {
                if (isDragging) {
                    hasDragged = true;
                    handlePositionUpdate(event.clientX);
                }
            }

            // 点击SVG跳转
            function handleClick(event) {
                // 只有在没有拖拽的情况下才响应点击
                if (!hasDragged) {
                    handlePositionUpdate(event.clientX);
                }
            }

            // 鼠标释放事件
            function handleMouseUp() {
                if (isDragging) {
                    isDragging = false;
                    document.getElementById("chartContainer").classList.remove("dragging");
                    const badge = document.querySelector(".point-badge");
                    if (badge) badge.style.cursor = "grab";

                    // 延迟重置hasDragged，以避免点击事件立即触发
                    setTimeout(() => {
                        hasDragged = false;
                    }, 100);
                }
            }

            // 页面加载时初始化
            // 获取路径元素并计算长度
            const paths = document.querySelectorAll('path[d="' + pathData + '"]');
            if (paths.length > 0) {
                pathElement = paths[0];
                pathLength = pathElement.getTotalLength();
            }

            // 初始化X轴标签位置
            initializeXAxisLabels();

            // 初始显示150人
            updateChart(150);

            // 添加拖拽事件监听
            const chartContainer = document.getElementById("chartContainer");
            chartContainer.addEventListener("mousedown", handleMouseDown);
            chartContainer.addEventListener("click", handleClick);
            document.addEventListener("mousemove", handleMouseMove);
            document.addEventListener("mouseup", handleMouseUp);

            // 触摸事件支持（移动端）
            chartContainer.addEventListener("touchstart", (e) => {
                const touch = e.touches[0];
                const mouseEvent = new MouseEvent("mousedown", {
                    clientX: touch.clientX,
                    clientY: touch.clientY,
                });
                handleMouseDown(mouseEvent);
            });

            document.addEventListener(
                "touchmove",
                (e) => {
                    if (isDragging) {
                        e.preventDefault();
                        const touch = e.touches[0];
                        handlePositionUpdate(touch.clientX);
                    }
                },
                { passive: false }
            );

            document.addEventListener("touchend", () => {
                handleMouseUp();
            });

            // 初始化X轴标签位置
            function initializeXAxisLabels() {
                const xAxis = document.getElementById("xAxis");
                const xAxisRect = xAxis.getBoundingClientRect();
                const chartSvg = document.getElementById("chartSvg");
                const svgRect = chartSvg.getBoundingClientRect();

                const labels = xAxis.querySelectorAll(".x-axis-label");
                labels.forEach((label) => {
                    const people = parseInt(label.getAttribute("data-people"));

                    // 计算该人数对应的X坐标（相对于SVG）
                    const targetX =
                        peopleStartX +
                        ((people - 1) / (maxPeople - 1)) * (peopleEndX - peopleStartX);

                    // 转换为实际像素位置
                    const scaleX = svgRect.width / svgViewBox.width;
                    const actualX = targetX * scaleX;

                    // 设置标签位置（相对于x-axis容器，需要考虑容器的padding）
                    const leftOffset = actualX;
                    label.style.left = leftOffset + "px";
                });
            }

            // 响应窗口大小变化
            window.addEventListener("resize", () => {
                const point = getPointOnPath(currentPeople);
                updateMarker(point, currentPeople);
                initializeXAxisLabels();
            });

            const section4SwiperConfig = {
                loop: true, // 循环
                speed: 6000,
                slidesPerView: "auto",
                spaceBetween: 60,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false,
                },

            };
            !isMobile && new Swiper(".section4Swiper", { ...section4SwiperConfig });
            isMobile && new Swiper(".section4SwiperM1", { ...section4SwiperConfig, spaceBetween: 20 });

            if (isMobile) {
                let section4SwiperM2 = new Swiper(".section4SwiperM2", {
                    ...section4SwiperConfig,
                    spaceBetween: 20,
                    autoplay: {
                        delay: 0,
                        disableOnInteraction: false,
                        reverseDirection: true

                    },
                });
                section4SwiperM2.autoplay.stop();
                setTimeout(() => {
                    section4SwiperM2.autoplay.start();
                }, 1000);
            }
            isMobile && new Swiper(".section8Swiper", { ...section4SwiperConfig, spaceBetween: 40, });



            function initMarquee(track, index) {
                if (!track) return;
                const originalContent = track.innerHTML;
                track.style.animationPlayState = 'paused';

                // 等浏览器渲染
                requestAnimationFrame(() => {
                    const originalWidth = track.scrollWidth;
                    track.innerHTML = originalContent + originalContent + originalContent + originalContent;
                    track.style.width = (originalWidth * 4) + 'px';
                    track.style.setProperty('--s7move-distance', `-${originalWidth * 2}px`);
                    track.style.animation = 'none';
                    requestAnimationFrame(() => {
                        track.style.animation = 'marquee 140s linear infinite';
                        index == 1 && (track.style.animationDirection = 'reverse')
                    });
                });
            }
            document.querySelectorAll('.marquee__track').forEach((track, index) => {
                initMarquee(track, index)
            });
            const starSvg =
                "path://M3.29892 8.43963L0 7.21565V6.78435L3.29892 5.56036C4.34804 5.17568 5.17569 4.34804 5.56037 3.29891L6.78435 0H7.21566L8.43963 3.29891C8.82431 4.34804 9.65196 5.17568 10.7011 5.56036L14 6.78435V7.21565L10.7011 8.43963C9.65196 8.82431 8.82431 9.65195 8.43963 10.7011L7.21566 14H6.78435L5.56037 10.7011C5.17569 9.65195 4.34804 8.82431 3.29892 8.43963Z";
            const startR = `<path d="M3.7613 9.62255L0 8.22702V7.73526L3.7613 6.33972C4.95748 5.90112 5.90113 4.95747 6.33973 3.7613L7.73526 0H8.22702L9.62255 3.7613C10.0611 4.95747 11.0048 5.90112 12.201 6.33972L15.9623 7.73526V8.22702L12.201 9.62255C11.0048 10.0611 10.0611 11.0048 9.62255 12.201L8.22702 15.9623H7.73526L6.33973 12.201C5.90113 11.0048 4.95748 10.0611 3.7613 9.62255Z" fill="#A52933"/>`;

            echarts.registerMap("world", geoJson);
            const chart = echarts.init(document.querySelector(".section6Map"));
            const data = [
                {
                    nameList: { "/zh-cn/": "阿根廷" },
                    name: "Argentina",
                    value: [-58.3816, -34.6037],
                },
                {
                    nameList: { "/zh-cn/": "澳大利亚" },
                    name: "Australia",
                    normal: true,
                    value: [151.2093, -33.8688],
                },
                // {
                //     nameList: { "/zh-cn/": "巴西" },
                //     name: "Brazil",
                //     value: [-47.8825, -15.7942],
                // },
                {
                    nameList: { "/zh-cn/": "智利" },
                    name: "Chile",
                    value: [-70.6693, -33.4489],
                },
                {
                    nameList: { "/zh-cn/": "哥伦比亚" },
                    name: "Colombia",
                    value: [-74.0721, 4.711],
                },
                {
                    nameList: { "/zh-cn/": "塞浦路斯" },
                    name: "Cyprus",
                    value: [33.3823, 35.1856],
                },
                {
                    nameList: { "/zh-cn/": "中国香港" },
                    name: "Hong Kong,China",
                    value: [114.1694, 22.3193],
                },
                {
                    nameList: { "/zh-cn/": "印度" },
                    name: "India",
                    value: [77.209, 28.6139],
                },
                {
                    nameList: { "/zh-cn/": "印度尼西亞" },
                    name: "Indonesia",
                    value: [106.8456, -6.2088],
                },
                {
                    nameList: { "/zh-cn/": "肯尼亚" },
                    normal: true,
                    name: "Kenya",
                    value: [36.8219, -1.2921],
                },
                // {
                //     nameList: { "/zh-cn/": "马来西亚" },
                //     name: "Malaysia",
                //     top: true,
                //     value: [101.6869, 3.1390],
                // },
                {
                    nameList: { "/zh-cn/": "墨西哥" },
                    name: "Mexico",
                    value: [-99.1332, 19.4326],
                },
                {
                    nameList: { "/zh-cn/": "尼日利亚" },
                    name: "Nigeria",
                    value: [7.4951, 9.0579],
                },
                {
                    nameList: { "/zh-cn/": "巴拿马" },
                    name: "Panama",
                    value: [-79.5199, 8.9824],
                },
                {
                    nameList: { "/zh-cn/": "秘鲁" },
                    normal: true,
                    name: "Peru",
                    value: [-77.0428, -12.0464],
                },
                {
                    nameList: { "/zh-cn/": "新加坡" },
                    name: "Singapore",
                    value: [103.8198, 1.3521],
                },
                {
                    nameList: { "/zh-cn/": "南非" },
                    name: "South Africa",
                    value: [28.2293, -25.7479],
                },
                {
                    nameList: { "/zh-cn/": "英国" },
                    hot: true,
                    name: "United Kingdom",
                    value: [-0.1278, 51.5074],
                },
                {
                    nameList: { "/zh-cn/": "乌拉圭" },
                    top: true,
                    name: "Uruguay",
                    value: [-56.1645, -34.9011],
                },
                {
                    nameList: { "/zh-cn/": "越南" },
                    top: true,
                    name: "Vietnam",
                    value: [105.8544, 21.0285],
                },
                {
                    nameList: { "/zh-cn/": "蒙古" },
                    normal: true,
                    name: "Mongolia",
                    value: [106.9057, 47.8864],
                },
                {
                    nameList: { "/zh-cn/": "韩国" },
                    name: "Korea",
                    value: [126.978, 37.5665],
                },
                {
                    nameList: { "/zh-cn/": "日本" },
                    name: "Japan",
                    value: [139.6917, 35.6895],
                },
                {
                    nameList: { "/zh-cn/": "开曼群岛" },
                    normal: true,
                    name: "Cayman ",
                    value: [-81.2546, 19.3133],
                },
                {
                    nameList: { "/zh-cn/": "泰国" },
                    name: "Thailand",
                    value: [102.6331, 17.9757],
                },
                // {
                //     nameList: { "/zh-cn/": "中国台湾" },
                //     name: "Taiwan",
                //     value: [121.5654, 25.0330],
                // },
                {
                    nameList: { "/zh-cn/": "老挝" },
                    name: "Laos",
                    top: true,
                    value: [102.6303, 17.9757],
                }
            ];

            data.forEach(function (item) {
                Object.keys(item.nameList).forEach((key) => {
                    if (key == '/zh-cn/') {
                        item.name = item.nameList[key];
                    }
                });
            });

            // 关键修改：给每个数据项添加 label.color
            const dataTop = data.filter((item) => item.top).map(item => ({
                ...item,
                label: {
                    color: "#a52933"
                }
            }));

            const dataBottom = data.filter((item) => !item.top).map(item => ({
                ...item,
                label: {
                    color: "#a52933"
                }
            }));

            const baseSeries = {
                type: "scatter",
                coordinateSystem: "geo",
                data: dataTop,
                symbol: starSvg, // 自定义星形
                symbolSize: 14,
                itemStyle: {
                    color: function (params) {
                        const item = params.data;
                        return "#a52933"; // 默认
                    },
                }, // 星形填充
                tooltip: {
                    show: false,
                },
                label: {
                    show: true,
                    formatter: "{b}",
                    position: "top",
                    distance: 5,
                    fontSize: 12,
                    fontWeight: 700,
                    lineHeight: 24,
                    // 移除 color 回调，让每个数据项的 label.color 生效
                },
                emphasis: {
                    disabled: true, // 完全禁用scatter点的高亮效果
                    label: {
                        show: true, // 标签始终显示
                    },
                },
            };

            chart.setOption({
                backgroundColor: "#fff", // 空白区域 #fff
                // 顶层禁用tooltip
                tooltip: {
                    show: false,
                    trigger: "none",
                },
                geo: {
                    map: "world",
                    roam: true,
                    zoom: isMobile ? 3.5 : 1.9,
                    layoutCenter: [isMobile ? "-80%" : "42%", "50%"],           // x < 50% 就是往左
                    layoutSize: isMobile ? "220%" : "140%",
                    scaleLimit: {
                        min: isMobile ? 2 : 1.2,
                        max: isMobile ? 5 : 3,
                    },
                    tooltip: {
                        show: false,
                    },
                    silent: false,
                    itemStyle: {
                        areaColor: "#E6DDCF", // 陆地 #E6DDCF
                        borderColor: "#d3c4b4",
                        borderWidth: 0.8,
                    },
                    emphasis: {
                        disabled: false, // 允许高亮
                        itemStyle: { areaColor: "#dcc9b5" },
                        label: {
                            show: false, // 禁用高亮时的文字标签
                        },
                    },
                },
                series: [
                    baseSeries,
                    {
                        ...baseSeries,
                        data: dataBottom,
                        label: {
                            ...baseSeries.label,
                            position: "bottom",
                        },
                    },
                ],
            });

            const LABEL_SHOW_ZOOM = isMobile ? 2.8 : 1.5;
            chart.on("georoam", function (params) {
                if (params.componentType === "geo") {
                    const option = chart.getOption();
                    const currentZoom = option.geo[0].zoom;
                    const shouldShowLabel = currentZoom >= LABEL_SHOW_ZOOM;
                    chart.setOption({
                        series: [
                            {
                                label: {
                                    show: shouldShowLabel,
                                },
                                emphasis: {
                                    label: {
                                        show: shouldShowLabel,
                                    },
                                },
                            },
                            {
                                label: {
                                    show: shouldShowLabel,
                                },
                                emphasis: {
                                    label: {
                                        show: shouldShowLabel,
                                    },
                                },
                            },
                        ],
                    });
                }
            });

            const initialOption = chart.getOption();
            const initialZoom = initialOption.geo[0].zoom;
            if (initialZoom >= LABEL_SHOW_ZOOM) {
                chart.setOption({
                    series: [
                        {
                            label: { show: true },
                            emphasis: { label: { show: true } },
                        },
                        {
                            label: { show: true },
                            emphasis: { label: { show: true } },
                        },
                    ],
                });
            }

            // 4. 自适应
            window.addEventListener("resize", () => chart.resize());

            let dialog = document.querySelector(".pageDial");
            let pageShadow = document.querySelector(".pageShadow");
            document.querySelector('.guideDial').addEventListener('click', function () {
                dialog.classList.toggle('showDial')
                pageShadow.classList.toggle('showShadow')
            })
            document.querySelector('.closeTag').addEventListener('click', function () {
                dialog.classList.toggle('showDial')
                pageShadow.classList.toggle('showShadow')
            })

            // 头部设置
            isMobile && (() => {
                // document.querySelector('#langSelectorM').innerHTML = `<span class="iconfont icon-navigate-menu"></span>`
                document.querySelector('#langSelectorM').style.display = 'inline-block'
                let loginBtn = document.querySelector('.navigate-entry-link a:nth-child(3)').cloneNode(true)
                langSelectorM.innerHTML = `<span class="iconfont icon-navigate-menu"></span>`
                const ref = document.querySelector('#langSelectorM');
                ref.parentNode.insertBefore(loginBtn, ref);
            })()

            // 第二屏（aff-section2）卡片轮播：仅移动端启用
            const cards = document.querySelectorAll('.section2-card');
            let currentIndex = 0;
            const totalCards = cards.length;
            if (isMobile && totalCards) {

                function updateCardsPosition() {
                    // 计算每张卡片的目标位置
                    const positions = [];
                    cards.forEach((card, index) => {
                        const relativePos = (index - currentIndex + totalCards) % totalCards;
                        let targetClass = '';

                        if (relativePos === 0) targetClass = 'center';
                        else if (relativePos === 1) targetClass = 'bottom';
                        else if (relativePos === totalCards - 1) targetClass = 'top';
                        else if (relativePos === totalCards - 2) targetClass = 'hidden-top';
                        else targetClass = 'hidden-bottom';

                        positions.push({ card, targetClass });
                    });

                    // 逐张更新（避免批量操作冲突）
                    positions.forEach(({ card, targetClass }, idx) => {
                        setTimeout(() => {
                            // 简单粗暴：直接设置类
                            card.className = 'section2-card ' + targetClass;

                            // bottom 特殊处理：进入 bottom 时“秒出”，避免出现下落/抖动
                            // 原先 setTimeout(50ms) 在手机上容易发生样式未生效就开始过渡，导致看起来从上面掉下来
                            if (targetClass === 'bottom') {
                                // 先把它放到 hidden-bottom，并禁止过渡，确保这一帧完全不可见/不动画
                                card.className = 'section2-card hidden-bottom no-transition';
                                // 强制 reflow，保证 hidden-bottom 样式落地
                                void card.offsetWidth;
                                // 下一帧切到 bottom：保留一个很短的缩放出现（fast-transition）
                                requestAnimationFrame(() => {
                                    // 先恢复过渡（但用 fast-transition 缩短），再切到 bottom 触发缩放/淡入
                                    card.className = 'section2-card hidden-bottom fast-transition';
                                    void card.offsetWidth;
                                    card.className = 'section2-card bottom fast-transition';

                                    // 动画结束后移除 fast-transition，回到默认过渡时间
                                    const onEnd = (e) => {
                                        if (e.propertyName !== 'transform' && e.propertyName !== 'opacity') return;
                                        card.classList.remove('fast-transition');
                                        card.removeEventListener('transitionend', onEnd);
                                    };
                                    card.addEventListener('transitionend', onEnd);
                                });
                            }
                        }, idx * 10); // 每张卡片延迟 10ms
                    });
                }


                // 下一张
                function nextCard() {
                    currentIndex = (currentIndex + 1) % totalCards;
                    updateCardsPosition();
                }

                // 上一张
                function prevCard() {
                    currentIndex = (currentIndex - 1 + totalCards) % totalCards;
                    updateCardsPosition();
                }

                // 初始化
                updateCardsPosition();

                // 自动轮播 - 增加间隔确保动画完成（0.6s 过渡 + 缓冲时间）
                let autoPlayInterval = setInterval(nextCard, 4000);

                // 触摸滑动支持
                let touchStartY = 0;
                let touchEndY = 0;

                const container = document.querySelector('.section2-cardList');

                container.addEventListener('touchstart', (e) => {
                    touchStartY = e.touches[0].clientY;
                    clearInterval(autoPlayInterval);
                }, { passive: true });

                container.addEventListener('touchend', (e) => {
                    touchEndY = e.changedTouches[0].clientY;
                    const diff = touchStartY - touchEndY;

                    if (Math.abs(diff) > 50) {
                        if (diff > 0) {
                            // 向上滑动 - 下一张
                            nextCard();
                        } else {
                            // 向下滑动 - 上一张
                            prevCard();
                        }
                    }

                    // 重启自动播放
                    autoPlayInterval = setInterval(nextCard, 4000);
                }, { passive: true });

                // 窗口大小改变时重新初始化
                let resizeTimer;
                window.addEventListener('resize', () => {
                    clearTimeout(resizeTimer);
                    resizeTimer = setTimeout(() => {
                        if (window.innerWidth <= 996) {
                            updateCardsPosition();
                        } else {
                            // 桌面端移除所有位置类
                            cards.forEach(card => {
                                card.classList.remove('center', 'top', 'bottom', 'hidden-top', 'hidden-bottom');
                            });
                            clearInterval(autoPlayInterval);
                        }
                    }, 250);
                });
            }
            function numberAnimate() {
                console.log("numberAn");
                const cfg = {
                    1: [390, 0, "390B+", ""], // 1 000
                    2: [498, 0, "$498K+", ""], // 20
                    3: [100, 0, "100+", ""], // 98.75%
                    4: [24, 0, "24H", ""], // 6.0 → 0.0（倒计时）
                };

                Object.keys(cfg).forEach((key) => {
                    const [end, decimals, prefix] = cfg[key];
                    const $el = $(
                        window.matchMedia("(max-width: 996px)").matches
                            ? ``
                            : `.section2-card:nth-child(${key}) .section2-cardDesc`,
                    );
                    $({ countNum: decimals === 1 ? 60 : 0 }).animate(
                        { countNum: end },
                        {
                            duration: 700,
                            easing: "linear",
                            step() {
                                const val =
                                    decimals > 0
                                        ? (this.countNum / 10).toFixed(1)
                                        : Math.floor(this.countNum);
                                $el.eq(0).text(val);
                            },
                            complete() {
                                const final = prefix;
                                $el.eq(0).text(final);
                            },
                        },
                    );
                });
            }
            !isMobile &&
                (function () {
                    const mobileSection2DataList = new IntersectionObserver(
                        (entries) => {
                            entries.forEach((e) => {
                                if (e.isIntersecting) {
                                    numberAnimate();
                                    mobileSection2DataList.disconnect(e.target);
                                }
                            });
                        },
                        { threshold: 0.5 },
                    );
                    mobileSection2DataList.observe(document.querySelector(".aff-section2"));
                })();
        }
    },
    computed: {

        ...mapGetters([
            'signupUrl',
        ])
    },
}
</script>
<style scoped>
a {
    text-decoration: none;
}

.contentBox {
    max-width: 1200rem;
    margin-inline: auto;
    overflow: hidden;
}

.aff-section1 {
    padding-block: calc(80px + 30rem) 40rem;
}

.aff-section1 .section1Container {
    width: 1440rem;
    height: 640rem;
    margin-inline: auto;
    border-radius: 16px;
    padding-top: 390rem;
    box-sizing: border-box;
    position: relative;
    background: linear-gradient(0deg,
            rgba(0, 0, 0, 0.32) -6.03%,
            rgba(0, 0, 0, 0.15) 46.69%,
            rgba(0, 0, 0, 0) 74.46%,
            rgba(0, 0, 0, 0) 106.21%);
    overflow: hidden;
}

.aff-section1 img {
    width: 100%;
    height: 100%;
    position: absolute;
    inset: 0;
    z-index: -1;
}

.aff-section1 .headerTitle {
    color: var(--ebc-text-primary_white);
    text-align: center;
    font-size: 60rem;
    font-weight: 700;
    line-height: 1;
}

.aff-section1 .headerDesc {
    color: var(--ebc-text-primary_white);
    text-align: center;
    font-size: 20rem;
    font-weight: 400;
    line-height: 1;
    margin: 22rem 0 28rem;
}

.aff-section1 .headerBtn {
    border-radius: 42rem;
    background-color: var(--ebc-text-primary_white);
    color: var(--ebc-brand-secondary-red);
    text-align: center;
    font-size: 20rem;
    font-weight: 500;
    line-height: 1;
    width: fit-content;
    min-width: 220rem;
    height: 52rem;
    margin-inline: auto;
}

.aff-section1 .headerBtn:hover {
    background-color: #a52933;
    color: var(--ebc-text-primary_white);
}

@media (max-width: 996px) {
    .aff-section1 {
        padding: 52rem 32rem 72rem;
    }

    .aff-section1 .section1Container {
        width: 100%;
        height: auto;
        padding-top: 0;
        border-radius: 0;
        background: unset;
    }

    .aff-section1 img {
        position: static;
        margin-bottom: 48rem;
        width: 686rem;
        height: 456rem;
        object-fit: cover;
        border-radius: 8px;
        border: 2px solid rgba(0, 0, 0, 0.12);
        box-sizing: border-box;
    }

    .aff-section1 .headerTitle {
        color: var(--ebc-text-primary);
        font-size: 64rem;
        font-weight: 700;
        line-height: 1;
    }

    .aff-section1 .headerDesc {
        color: var(--ebc-text-secondary);
        font-size: 28rem;
        font-weight: 400;
        line-height: 44rem;
        margin: 16rem 0 48rem;
    }

    .aff-section1 .headerBtn {
        height: 80rem;
        min-width: 326rem;
        background-color: #a52933;
        color: var(--ebc-text-primary_white);
        font-size: 28rem;
        font-weight: 500;
        line-height: 1;
    }
}

.aff-section2 {
    padding-block: 78rem;
    background: url("../assets/image/Affiliate/section2Bg.png") 100% 100% / cover no-repeat;
}

.aff-section2 .section2-cardTitle {
    color: var(--ebc-brand-primary-limestone);
    font-size: 16rem;
    font-weight: 400;
    line-height: 24rem;
    margin-bottom: 5rem;
}

.aff-section2 .section2-cardDesc {
    color: var(--ebc-neutral-beige);
    font-size: 56rem;
    font-style: normal;
    font-weight: 700;
    line-height: 66rem;
}



.aff-section3 {
    padding-block: 100rem;
}

.aff-section4 h2,
.aff-section9 h2,
.aff-section10 h2,
.aff-section8 h2,
.aff-section6 h2,
.aff-section5 h2,
.aff-section3 h2 {
    padding-left: 100rem;
    color: var(--ebc-brand-primary-burgundy);
    font-size: 44rem;
    font-weight: 700;
    line-height: 1;
}

.aff-section4 h3,
.aff-section6 h3,
.aff-section3 h3 {
    padding-left: 100rem;
    color: #333;
    font-size: 18rem;
    font-weight: 400;
    line-height: 1;
    margin-block: 24rem 40rem;
}

.aff-section3 .container {
    margin: 0 auto;
    background: white;
    padding: 55rem 25rem 45rem;
    border-radius: 20px;
    border: 1px solid #f1f1f1;
    background: #fcfcfc;
}

.aff-section3 .commission-title {
    color: #333;
    font-size: 18px;
    font-weight: 400;
    line-height: 1;
    margin-bottom: 15rem;
    margin-left: 75rem;
}

.aff-section3 .commission-amount {
    color: var(--ebc-brand-accent-coral, #ff4b4e);
    font-size: 64rem;
    font-style: normal;
    font-weight: 700;
    line-height: 80rem;
    margin-left: 75rem;
}

.aff-section3 .chart-wrapper {
    position: relative;
    width: 100%;
    padding-bottom: 10px;
}

.aff-section3 .chart-container {
    position: relative;
    width: 100%;
    height: 337rem;
    cursor: default;
}

.aff-section3 .chart-container.dragging {
    cursor: grabbing;
}

.aff-section3 .chart-svg {
    width: 100%;
    height: 100%;
    display: block;
}

.aff-section3 .x-axis {
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    margin-top: 10px;
}

.aff-section3 .x-axis-label {
    color: var(--ebc-text-secondary);
    font-size: 18rem;
    font-weight: 400;
    line-height: 1;
    margin-top: 9rem;
    white-space: nowrap;
}

.aff-section3 .x-axis-label:nth-child(-n + 3) {
    transform: translateX(50%);
}

.aff-section3 .x-axis-label:nth-child(4),
.aff-section3 .x-axis-label:nth-child(5) {
    transform: translateX(30%);
}



.aff-section3 .description {
    color: rgba(0, 0, 0, 0.24);
    margin-left: 75rem;
    margin-top: 28rem;
}

@media (max-width: 996px) {

    .aff-section4 h2,
    .aff-section6 h2,
    .aff-section8 h2,
    .aff-section9 h2,
    .aff-section5 h2,
    .aff-section10 h2,
    .aff-section3 h2 {
        padding-left: 0;
        text-align: center;
        color: var(--ebc-brand-primary-burgundy);
        font-size: 48rem;
        font-weight: 700;
        max-width: calc(100vw - 64rem);
        margin-inline: auto;
    }

    .aff-section4 h3,
    .aff-section6 h3,
    .aff-section3 h3 {
        max-width: calc(100vw - 64rem);

        padding-left: 0;
        color: #333;
        font-size: 28rem;
        line-height: 44rem;
        margin-block: 16rem 60rem;
        text-align: center;
    }

    .aff-section3 h3 {
        margin-inline: auto;
    }

    .aff-section3 .container {
        border-radius: 0;
        padding: 56rem 15rem;
    }

    .aff-section3 .description {
        color: rgba(0, 0, 0, 0.24);
        font-size: 24rem;
        line-height: 40rem;
        margin: 0;
        padding-inline: 17rem;
        margin-top: 64rem;
    }

    .aff-section3 .commission-title {
        font-size: 24rem;
        line-height: 40rem;
        margin-bottom: 16rem;
        margin-inline: auto;
        width: 405rem;
    }

    .aff-section3 .commission-amount {
        font-size: 96rem;
        line-height: 112rem;
        margin-inline: auto;
        width: 405rem;
    }

    .x-axis .x-axis-label:nth-child(even),
    .chart-svg line:nth-child(even) {
        display: none;
    }

    .aff-section3 .x-axis-label:nth-child(7) {
        transform: translateX(30%);
    }

    .aff-section3 .x-axis-label:nth-child(3) {
        transform: translateX(10%);
    }

    .aff-section3 .x-axis-label:nth-child(1) {
        transform: translateX(-30%);
    }
}

.aff-section4 {
    background-color: #f6f6f6;
    padding: 100rem 0;
}

.aff-section4 .swiper {
    position: relative;
}

.aff-section4 h3 {
    margin-bottom: 60rem;
}

.aff-section4 .section4Swiper {
    position: relative;
}

.aff-section4 .shadow,
.aff-section7 .shadow {
    position: absolute;
    top: 0;
    height: 100%;
    width: 330rem;
    z-index: 2;
}

.aff-section4 .leftShadow,
.aff-section7 .leftShadow {
    background: linear-gradient(270deg, rgba(245, 245, 245, 0) 0%, #f5f5f5 100%);
    left: 0;
}

.aff-section4 .rightShadow,
.aff-section7 .rightShadow {
    background: linear-gradient(270deg, #f5f5f5 0%, rgba(245, 245, 245, 0) 100%);
    right: 0;
}

.aff-section4 .section4Swiper img {
    max-height: 58rem;
    width: auto;
}

.swiper-wrapper {
    transition-timing-function: linear !important;
}

.aff-section4 .section4Swiper .swiper-slide {
    width: fit-content;
}

@media (max-width: 996px) {

    .aff-section4 h2,
    .aff-section4 h3 {
        margin-inline: auto;
    }

    .aff-section4 .section4SwiperM1 {
        margin-bottom: 25rem;
    }

    .aff-section4 .section4SwiperM2 .swiper-slide,
    .aff-section4 .section4SwiperM1 .swiper-slide {
        width: fit-content;
    }

    .aff-section4 .shadow {
        width: 150rem;
    }

    .aff-section4 .swiper img {
        max-height: 50rem;
        width: auto;
    }

    .aff-section4 .section4SwiperM2 img {
        max-height: 40rem;
        width: auto;
    }
}

.aff-section5 {
    padding-block: 100rem;
}

.aff-section5 .section5CardList {
    gap: 40rem;
    margin-top: 40rem;
}

.aff-section5 .section5Card {
    padding: 50rem 30rem;
    text-align: center;
    border-radius: 20px;
    background: #fafafa;
    flex: 0 0 320rem;
    box-sizing: border-box;
    transition: transform 0.3s;
}

@media (min-width: 996px) {
    .aff-section5 .section5Card:hover {
        transform: translateY(-20rem);
    }
}


.aff-section5 .section5Card img {
    width: 80rem;
    height: 80rem;
}

.aff-section5 .section5Card .cardTip {
    font-size: 24rem;
    font-weight: 500;
    line-height: 1;
    margin-block: 40rem 20rem;
}

.aff-section5 .section5Card .cardDesc {
    color: var(--ebc-text-secondary);
    font-size: 14rem;
    font-weight: 400;
    line-height: 1.2;
}

.aff-section5 .contentBox {
    position: relative;
}

.aff-section5 .section5Btn {
    position: absolute;
    right: 80rem;
    top: 0;
    gap: 5rem;
    border-radius: 24px;
    background: var(--ebc-neutral-beige);
    color: var(--ebc-brand-secondary-red);
    font-size: 20rem;
    font-weight: 500;
    line-height: 1;
    height: 48rem;
    min-width: 160rem;
    padding-inline: 15rem;
}

@media (min-width: 996px) {
    .aff-section5 .section5Btn:hover {
        background: var(--ebc-brand-secondary-red);
        color: var(--ebc-text-primary_white);
    }
}

@media (max-width: 996px) {
    .aff-section5 {
        padding: 120rem 16rem;
    }

    .aff-section5 .section5CardList {
        flex-direction: column;
    }
}

@media (max-width: 996px) {
    .aff-section5 {
        padding: 120rem 16rem;
    }

    .aff-section5 .section5CardList {
        flex-direction: column;
    }

    .aff-section5 .section5Btn {
        position: static;
        margin-block: 64rem;
        min-width: 326rem;
        width: fit-content;
        height: 80rem;
        background: #a52933;
        color: var(--ebc-text-primary_white);
        font-size: 28rem;
        font-weight: 500;
        line-height: 1;
        margin-inline: auto;
    }

    .aff-section5 .section5Card {
        display: flex;
        padding: 48rem 32rem 48rem 50rem;
        align-items: center;
        justify-content: flex-start;
        gap: 52rem;
        flex: 1;
        padding-block: 42rem;
        width: 100%;
    }

    .aff-section5 .section5Card img {
        width: 100rem;
        height: 100rem;
    }

    .aff-section5 .section5Card .cardTip {
        margin-block: 0 16rem;
        font-size: 32rem;
        line-height: 1;
        text-align: left;
    }

    .aff-section5 .section5Card .cardDesc {
        font-size: 24rem;
        line-height: 1.3;
        text-align: left;
    }
}

.aff-section6 {
    padding: 100rem 0;
    background: #fafafa;
}

.aff-section6 h3 {
    line-height: 32rem;
}

.aff-section6 .section6Map {
    height: 630rem;
    border-radius: 12px;
    overflow: hidden;
}

.aff-section6 .mapLegend {
    gap: 50rem;
    margin-top: 40rem;
}

.aff-section6 .mapLegend .legendItem:nth-child(2) {
    display: none;
}

.aff-section6 .mapLegend .legendLabel {
    color: var(--ebc-text-secondary);
    font-size: 16rem;
    font-weight: 400;
    line-height: 1;
    margin-left: 8rem;
}

@media (max-width: 996px) {
    .aff-section6 {
        padding: 120rem 32rem;
    }

    .aff-section6 h3 {
        margin-block: 32rem 48rem;
    }

    .aff-section6 .section6Map {
        height: 445rem;
    }

    .aff-section6 .mapLegend {
        display: none;
    }
}

.aff-section7 {
    padding-block: 60rem;
    background: var(--ebc-neutral-beige);
}

.aff-section7 .swiperWordTag {
    border-radius: var(--Corner-Radius-Full, 999px);
    background: #f04553;
    backdrop-filter: blur(8px);
    padding: 12rem 28rem;
}

.aff-section7 .swiperLogoTag {
    width: 48rem;
    height: 48rem;
}

.aff-section7 .section7SwiperList {
    position: relative;
}

.aff-section7 .section7SwiperList .marquee:nth-child(-n + 4) {
    margin-bottom: 28rem;
}

.aff-section7 .swiper-slide {
    width: fit-content;

    color: #fff;
    text-align: center;
    font-size: 20rem;
    font-weight: 500;
    line-height: 1;
}

.marquee {
    overflow: hidden;
    width: 100%;
}

.marquee--reverse.marquee__track {
    animation-direction: reverse;
}

.marquee__track {
    display: inline-flex;
    /* align-items: center; */
    gap: 20px;
    /* 对应 spaceBetween */

    /* 强制硬件加速 */
    /* transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0); */
    /* will-change: transform; */
    /* backface-visibility: hidden; */
    /* -webkit-backface-visibility: hidden; */
    animation: marquee 140s linear infinite;
    /* 调整 30s 控制速度 */
}


@media (max-width: 996px) {
    .aff-section7 .section7SwiperList .marquee:nth-child(-n + 4) {
        margin-bottom: 45rem;
    }

    .aff-section7 .swiperWordTag {
        padding: 20rem 46rem;
    }

    .aff-section7 .swiper-slide {
        font-size: 33rem;
        transition: none;

    }

    .marquee__track {
        gap: 33rem;
        animation: marquee 140s linear infinite;
        /* 调整 30s 控制速度 */
    }

    .aff-section7 .shadow {
        width: 130rem;
    }

    .aff-section7 .swiperLogoTag {
        width: 80rem;
        height: 80rem;
    }
}

.aff-section8 {
    padding: 100rem 0;
}

.aff-section8 h2 {
    padding-left: 100rem;
    margin-bottom: 40rem;
}

.aff-section8 .techerList {
    row-gap: 12rem;
}

.aff-section8 .teacherCard {
    flex: 0 0 290rem;
    height: 330rem;
    border-radius: 16px;
    overflow: hidden;
    position: relative;
}

.aff-section8 .teacherCard img {
    width: 100%;
    height: 100%;
}

.aff-section8 .teacherCard .tag {
    padding: 12rem 16rem;
    border-radius: 42px;
    font-size: 14rem;
    font-weight: 500;
    line-height: 1;
    position: absolute;
    left: 23rem;
}

.aff-section8 .teacherCard .nameTag {
    background: var(--ebc-brand-accent-coral);
    color: #FFF;
    top: 220rem;
}

.aff-section8 .teacherCard .workTag {
    background: var(--ebc-brand-primary-limestone);
    color: var(--ebc-text-primary);
    top: 265rem;
    max-width: 242rem;
    box-sizing: border-box;
    font-size: 14rem;
    line-height: 16rem;
}

@media (max-width: 996px) {
    .aff-section8 {
        padding: 120rem 0;
    }

    .aff-section8 h2 {
        padding-left: 0;
        margin-bottom: 64rem;
        text-align: center;
    }

    .aff-section8 .techerList {
        flex-wrap: nowrap !important;
    }

    .aff-section8 .teacherCard {
        flex: 0 0 587rem;
        height: 688rem;
        border-radius: 16px;
        overflow: hidden;
        position: relative;
    }

    .aff-section8 .teacherCard .nameTag {
        top: 457rem;
    }

    .aff-section8 .teacherCard .workTag {
        top: 555rem;
        max-width: 500rem;
    }

    .aff-section8 .teacherCard .tag {
        padding: 25rem 33rem;
        border-radius: 42px;
        font-size: 32rem;
        position: absolute;
        left: 43rem;
        line-height: 35rem;
    }
}

.aff-section9 {
    padding: 80rem 0;
    background: #F6F6F6;
}

.aff-section9 a:hover {
    color: #fff;
}

.aff-section9 .v-marquee {
    --h: 525rem;
    --gap: 20rem;
    --speed: 25s;

    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20rem;
    height: var(--h);
    overflow: hidden;
    min-width: 536rem;
}

.aff-section9 .v-col {
    position: relative;
    overflow: hidden;
    height: 100%;
}

/* 关键：不用 flex gap，改用 margin */
.aff-section9 .v-track {
    display: flex;
    flex-direction: column;
    gap: 0;
    /* 关键：设为0 */
    transform: translate3d(0, 0, 0);
    -webkit-transform: translate3d(0, 0, 0);
    will-change: transform;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    -webkit-perspective: 1000;
    perspective: 1000;
    animation: vScroll var(--speed) linear infinite;
}

.aff-section9 .v-track--right {
    animation-delay: calc(var(--speed) * -0.1);
}

.aff-section9 .v-col .shadow {
    position: absolute;
    left: 0;
    right: 0;
    height: 150rem;
    z-index: 2;
}

.aff-section9 .v-col .topShadow {
    box-shadow: unset !important;

    background: linear-gradient(180deg, #f6f6f6 0%, rgba(246, 246, 246, .56) 59.2%, rgba(246, 246, 246, 0.00) 100%);
    top: -2rem;
}

.aff-section9 .v-col .bottomShadow {
    box-shadow: unset !important;

    background: linear-gradient(0deg, #f6f6f6 0%, rgba(246, 246, 246, .56) 59.2%, rgba(246, 246, 246, 0.00) 100%);
    bottom: -2rem;
}



.aff-section9 .v-track--right {
    animation: vScroll var(--speed) linear infinite;
    animation-direction: reverse;

}

.aff-section9 .v-track--right {
    animation-delay: calc(var(--speed) * -0.1);
    /* 关键：错开开始时间 */
}

/* 用 margin-bottom 代替 gap */
.aff-section9 .v-img {
    width: 258rem;
    height: 327rem;
    min-height: 327rem;
    max-height: 327rem;
    display: block;
    margin-bottom: var(--gap);
    transform: translateZ(0);
    -webkit-transform: translateZ(0);
}



@keyframes vScroll {
    0% {
        transform: translate3d(0, 0, 0);
    }

    100% {
        transform: translate3d(0, -50%, 0);
    }
}

.aff-section9 .contentBox {
    gap: 60rem;
}

.aff-section9 h2 {
    padding-left: 0;
}

.aff-section9 h3 {
    color: #999;
    font-size: 18rem;
    font-weight: 400;
    line-height: 32rem;
    margin-block: 28rem;
}

.aff-section9 .s9Right a {
    width: fit-content;
    min-width: 220rem;
}

@media (max-width: 996px) {
    .aff-section9 .v-col .shadow {
        height: 330rem;
    }

    .aff-section9 .v-col .topShadow {
        background: linear-gradient(180deg, #fff 0%, rgba(255, 255, 255, .56) 59.2%, rgba(246, 246, 246, 0.00) 100%);
        top: -2rem;
    }

    .aff-section9 .v-col .bottomShadow {
        background: linear-gradient(0deg, #fff 0%, rgba(255, 255, 255, .56) 59.2%, rgba(246, 246, 246, 0.00) 100%);
        bottom: -2rem;
    }

    .aff-section9 {
        padding: 120rem 32rem;
        background: var(--ebc-text-primary_white);
    }

    .aff-section10 {
        background: #f6f6f6;

    }

    .aff-section9 h3 {
        color: var(--ebc-text-secondary);
        text-align: center;
        font-size: 28.638rem;
        line-height: 49.093rem;
        margin-block: 30rem 64rem;
    }

    .aff-section9 .contentBox {
        gap: 0;
    }

    .aff-section9 .s9Right a {
        display: none;
    }

    .aff-section9 .contentBox {
        flex-direction: column;
    }

    .aff-section9 .s9Left {
        order: 2;
    }

    .aff-section9 .mobile {
        order: 3;
    }

    .aff-section9 .v-marquee {
        flex: 0 0 1046rem;
        --itemH: 420rem;
    }

    .aff-section9 .v-img {
        width: 330rem;
        height: 420rem;
        max-height: 420rem;
        min-height: 420rem;
    }

    .aff-section9 .mobile a {
        height: 80rem;
        min-width: 326rem;
        font-size: 28rem;
        margin-top: 64rem;
    }
}

.aff-section10 .guideDial {
    color: var(--ebc-brand-secondary-red);
}

.pageShadow {
    background: var(--ebc-neutral-mask);
    position: fixed;
    inset: 0;
    z-index: -111;
    opacity: 0;
    transition: opacity 0.3s;
}

.pageShadow.showShadow {
    z-index: 100;
    opacity: 1;
}

.pageDial.showDial {
    opacity: 1;
    bottom: 50vh;
}

.pageDial {
    opacity: 0;
    position: fixed;
    bottom: -999px;
    left: 50%;
    transition: transform 0.5s, opacity 0.5s;
    padding: 32rem;
    width: 950rem;
    max-height: 550rem;
    border-radius: 16px;
    background: #FFF;
    z-index: 101;
    transform: translate(-50%, 275rem);
}

.pageDial .closeTag {
    position: absolute;
    top: 43rem;
    right: 32rem;
    width: 18rem;
    height: 18rem;
}

.pageDial .title-32_bold {
    padding-bottom: 15rem;
}

.pageDial .desc {
    margin-bottom: 12rem;
    color: var(--ebc-text-secondary);
}

.pageDial .title {
    margin-block: 2rem 16rem;
}

.pageDial .contentContainer {
    overflow: auto;
    max-height: 438rem;
    padding-right: 25rem;
}

@media (max-width: 996px) {
    .pageDial.showDial {
        bottom: 0;
    }

    .pageDial {
        width: 99vw;
        left: 0;
        transform: unset;
        max-height: 60vh;
        padding: 48rem 32rem;
        border-radius: 32rem 32rem 0 0;
        box-sizing: border-box;
    }

    .pageDial .contentContainer {
        max-height: 50vh;
    }

    .pageDial .title-32_bold {
        font-size: 48rem !important;
        line-height: 64rem !important;
        font-size: 48rem;
        line-height: 64rem;
        font-weight: 500;
    }

    .pageDial .title {
        margin: 35rem 0 24rem;
        font-size: 24rem;
        line-height: 32rem;
    }

    .pageDial .desc {
        margin-bottom: 0;
        font-size: 24rem;
        line-height: 40rem;
        font-size: 24rem;
        line-height: 32rem;
    }

    .pageDial .closeTag {
        right: 32rem;
        top: 55rem;
        width: 36rem;
        height: 36rem;
    }

    .pageDial .contentContainer {
        padding-right: 20rem;
    }
}

/* Affiliate Apply Modal (popup) */
.affApplyDial {
  opacity: 0;
  pointer-events: none;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) scale(0.98);
  transition: transform 0.25s ease, opacity 0.25s ease;
  padding: 32rem;
  width: 913rem;
  border-radius: 16rem;
  background: #fff;
  z-index: 102;
  box-shadow: 20rem 40rem 60rem rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}
.affApplyDial.showDial {
  opacity: 1;
  pointer-events: auto;
  transform: translate(-50%, -50%) scale(1);
}
.affApplyHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16rem;
  margin-bottom: 32rem;
}
.affApplyTitle {
  margin: 0;
  font-size: 32rem;
  line-height: 40rem;
  font-weight: 700;
  color: var(--ebc-text-primary);
}
.affApplyClose {
  width: 32rem;
  height: 32rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  color: var(--ebc-text-secondary);
  font-size: 32rem;
  line-height: 1;
  cursor: pointer;
  padding: 0;
}
.affApplyForm {
  display: flex;
  flex-direction: column;
  gap: 28rem;
}
.affApplyGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20rem;
}
.affApplyGrid > * {
  min-width: 0;
}
.affApplyField {
  display: flex;
  flex-direction: column;
  gap: 12rem;
  position: relative;
  min-width: 0;
}
.affApplyLabelRow {
  line-height: 22rem;
}

.affApplyLabel {
  color: var(--ebc-text-primary);
  font-size: 14rem;
  line-height: 22rem;
  font-weight: 400;
}
.affApplyHint {
  color: var(--ebc-text-secondary);
  font-size: 14rem;
  line-height: 22rem;
  font-weight: 400;
}
.affApplyControl {
  border: 1rem solid rgba(0, 0, 0, 0.12);
  border-radius: 8rem;
  height: 48rem;
  padding: 8rem 16rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12rem;
  box-sizing: border-box;
  background: #fff;
  min-width: 0;
}
.affApplyControl.is-error {
  border-color: var(--ebc-brand-secondary-red);
}
.affApplyInput {
  border: 0;
  outline: none;
  width: 100%;
  font-size: 14rem;
  line-height: 22rem;
  color: var(--ebc-text-primary);
  background: transparent;
}
.affApplyInput::placeholder {
  color: rgba(0, 0, 0, 0.24);
}
.affApplyTextarea {
  border: 0;
  outline: none;
  width: 100%;
  font-size: 14rem;
  line-height: 22rem;
  color: var(--ebc-text-primary);
  background: transparent;
  resize: none;
}
.affApplyTextarea::placeholder {
  color: rgba(0, 0, 0, 0.24);
}
.affApplySelectValue {
  font-size: 14rem;
  line-height: 22rem;
  color: var(--ebc-text-primary);
  min-width: 0;
  max-width: 100%;
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.affApplySelectValue.is-placeholder {
  color: rgba(0, 0, 0, 0.24);
}
.affApplyArrow {
  width: 20rem;
  height: 20rem;
  position: relative;
  flex: 0 0 20rem;
}
.affApplyArrow::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  width: 8rem;
  height: 8rem;
  border-right: 1.5rem solid rgba(0, 0, 0, 0.64);
  border-bottom: 1.5rem solid rgba(0, 0, 0, 0.64);
  transform: translate(-50%, -60%) rotate(45deg);
}
.affApplyDropdown {
  display: none;
  position: absolute;
  left: 0;
  top: calc(100% + 8rem);
  width: 100%;
  max-width: 100%;
  background: #fff;
  border: 1rem solid rgba(0, 0, 0, 0.12);
  border-radius: 8rem;
  box-shadow: 0 5rem 10rem rgba(0, 0, 0, 0.05);
  padding: 8rem;
  box-sizing: border-box;
  z-index: 103;
  max-height: 325rem;
  overflow: auto;
}
.affApplyField.open-up .affApplyDropdown {
  top: auto;
  bottom: calc(100% + 8rem);
}
.affApplyField.is-open .affApplyDropdown {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.affApplyOption {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12rem;
  font-size: 14rem;
  line-height: 22rem;
  color: var(--ebc-text-primary);
  cursor: pointer;
  padding: 8rem;
  border-radius: 4rem;
  user-select: none;
}
.affApplyOption > span:first-child {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.affApplyOption:hover {
  background: #f7f7f7;
}
.affApplyOption.is-selected {
  background: #f7f7f7;
}
.affApplyCheck {
  width: 20rem;
  height: 20rem;
  border: 1rem solid rgba(0, 0, 0, 0.12);
  border-radius: 4rem;
  box-sizing: border-box;
  flex: 0 0 20rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.affApplyOption.is-selected .affApplyCheck {
  background: var(--ebc-brand-secondary-red);
  border-color: var(--ebc-brand-secondary-red);
}
.affApplyOption.is-selected .affApplyCheck::after {
  content: "";
  width: 10rem;
  height: 6rem;
  border-left: 2rem solid #fff;
  border-bottom: 2rem solid #fff;
  transform: rotate(-45deg);
  margin-top: -1rem;
}
.affApplyError {
  display: none;
  font-size: 12rem;
  line-height: 18rem;
  color: var(--ebc-brand-secondary-red);
}
.affApplyField.has-error .affApplyError {
  display: block;
}
.affApplyActions {
  display: flex;
  justify-content: flex-end;
  gap: 12rem;
  margin-top: 4rem;
}
.affApplyBtn.is-loading {
  opacity: 0.8;
  cursor: wait;
}

/* Simple toast message (like el-message) */
.affMessageWrap {
  position: fixed;
  left: 50%;
  top: 150rem;
  transform: translateX(-50%);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 12rem;
  pointer-events: none;
  width: fit-content;
  max-width: calc(70vw);
}
.affMessage {
  pointer-events: auto;
  background: rgba(0, 0, 0, 0.78);
  color: #fff;
  border-radius: 12rem;
  padding: 14rem 16rem;
  font-size: 16rem;
  line-height: 22rem;
  box-shadow: 0 10rem 24rem rgba(0, 0, 0, 0.18);
  opacity: 0;
  transform: translateY(-6rem);
  transition: opacity 0.18s ease, transform 0.18s ease;
}
.affMessage.show {
  opacity: 1;
  transform: translateY(0);
}
.affMessage.is-error {
  color: #f56c6c;
  background: #fef0f0;
}
.affMessage.is-success {
  color: #67c23a;
  background: #f0f9eb;
}

@media (max-width: 996px) {
  .affApplyLabelRow {
    margin-bottom: 12rem;
}
  .affMessageWrap {
    top: 32rem;
    width: calc(100vw - 64rem);
  }
  .affMessage {
    font-size: 24rem;
    line-height: 32rem;
    padding: 20rem 24rem;
    border-radius: 16rem;
  }
}
.affApplyBtn {
  height: 48rem;
  padding: 10rem 48rem;
  border-radius: 999rem;
  font-size: 16rem;
  line-height: 28rem;
  font-weight: 500;
  cursor: pointer;
  border: 0;
  background: transparent;
}
.affApplyBtn--ghost {
  border: 1rem solid var(--ebc-brand-secondary-red);
  color: var(--ebc-brand-secondary-red);
}
.affApplyBtn--primary {
  background: var(--ebc-brand-secondary-red);
  color: var(--ebc-text-primary_white);
}
.affApplyBtn--primary:disabled {
  background: #ebadb2;
  cursor: not-allowed;
}

@media (max-width: 996px) {
.affApplyOption.is-selected .affApplyCheck::after {
  margin-top: -8rem;
}
  .affApplyDial {
    width: 100vw;
    left: 0;
    top: auto;
    bottom: -999px;
    transform: none;
    border-radius: 32rem 32rem 0 0;
    padding: 48rem 32rem;
    padding-top: 0;
    box-shadow: 0 -20rem 32rem rgba(0, 0, 0, 0.1);
    transition: bottom 0.25s ease, opacity 0.25s ease;
    max-height: 80vh;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
  .affApplyDial.showDial {
    bottom: 0;
    transform: none;
  }
  .affApplyHeader {
    position: sticky;
    top: 0;
    z-index: 104;
    background: #fff;
    padding-top: 48rem;
    padding-bottom: 24rem;
    margin-top: -8rem;
    margin-bottom: 24rem;
  }
  .affApplyTitle {
    font-size: 48rem;
    line-height: 64rem;
    font-weight: 500;
  }
  .affApplyClose {
    width: 48rem;
    height: 48rem;
    font-size: 48rem;
  }
  .affApplyGrid {
    grid-template-columns: 1fr;
    gap: 48rem;
  }
  .affApplyLabel,
  .affApplyHint {
    font-size: 28rem;
    line-height: 34rem;
  }
  .affApplyForm  .affApplyHint{
    display: block;
    margin-top: 8rem;
  }
  .affApplyControl {
    height: 88rem;
    padding: 16rem 32rem;
    border-radius: 16rem;
  }
  .affApplyInput,
  .affApplySelectValue,
  .affApplyTextarea {
    font-size: 28rem;
    line-height: 34rem;
  }
  .affApplyArrow {
    width: 40rem;
    height: 40rem;
    flex: 0 0 40rem;
  }
  .affApplyArrow::before {
    width: 14rem;
    height: 14rem;
    border-right-width: 3rem;
    border-bottom-width: 3rem;
  }
  .affApplyDropdown {
    padding: 32rem;
    border-radius: 16rem;
    max-height: 680rem;
    box-shadow: 0 10rem 10rem rgba(0, 0, 0, 0.05);
  }
  .affApplyOption {
    font-size: 28rem;
    line-height: 44rem;
    padding: 12rem 8rem;
    border-radius: 8rem;
  }
  .affApplyCheck {
    width: 40rem;
    height: 40rem;
    border-radius: 8rem;
    flex: 0 0 40rem;
  }
  .affApplyOption.is-selected .affApplyCheck::after {
    width: 18rem;
    height: 10rem;
    border-left-width: 4rem;
    border-bottom-width: 4rem;
  }
  .affApplyActions {
    justify-content: space-between;
    gap: 24rem;
  }
  .affApplyBtn {
    height: 96rem;
    padding: 20rem 96rem;
    font-size: 32rem;
    line-height: 56rem;
    border-radius: 1998rem;
    flex: 1 1 0;
  }
}
</style>
<style lang="scss">
@import url("../assets/css/commonQuestion.scss");
@import url("../assets/css/affiliateHeader.scss");
@media (max-width: 996px) {
    .cn .aff-section2 {
        padding: 0;
        border-radius: 32px;
        margin: 32rem;
        background: url("../assets/image/Affiliate/section2Bgm.png") 100% 100% / cover no-repeat;
    }

    .cn .aff-section2 .section2-cardList {
        position: relative;
        height: 585rem;
        perspective: 1000px;
        perspective-origin: center center;
        overflow: hidden;
        /* 统一的背景盒子 */
        border-radius: 24px;
        box-sizing: border-box;
        /* transform: translateY(-20px); */
    }

    .cn .aff-section2 .section2-card {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 85%;
        max-width: 350px;
        background: transparent;
        padding: 0px 30px;
        border-radius: 0;
        box-shadow: none;
        text-align: center;
        /* 默认过渡（center/top 等）：稍慢一些更自然 */
        transition: transform 0.45s ease-out, opacity 0.45s ease-out;
        will-change: transform;
        /* 移动端优化 */
        -webkit-transform: translate(-50%, -50%);
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        -webkit-perspective: 1000;
        perspective: 1000;
        /* 用 flex 反转顺序 */
        display: flex;
        flex-direction: column-reverse;
    }

    /* 某些状态切换（尤其是进入 bottom）需要“秒出”，用此类临时关闭过渡 */
    .cn .aff-section2 .section2-card.no-transition {
        transition: none !important;
        -webkit-transition: none !important;
    }

    /* 进入 bottom 时用更快的“缩放出现”过渡（只作用一次，JS 会移除） */
    .cn .aff-section2 .section2-card.fast-transition {
        transition-duration: 0.18s !important;
        -webkit-transition-duration: 0.18s !important;
    }

    .cn .aff-section2 .section2-cardDesc {
        font-size: 98rem;
        font-weight: 900;
        line-height: 1.2;
        margin-top: 10px;
        /* 避免从纯色 -> 渐变文字时出现“先白一下再渐变”的过渡 */
        transition: none;
    }

    .cn .aff-section2 .section2-cardTitle {
        font-size: 28rem;
        margin-bottom: 0;
        line-height: 1.2;
        /* 避免从纯色 -> 渐变文字时出现“先白一下再渐变”的过渡 */
        transition: none;
    }

    /* 中心位置 - 最前面、最大 */
    .cn .aff-section2 .section2-card.center {
        transform: translate(-50%, -50%) translateZ(0px) scale(1) !important;
        -webkit-transform: translate(-50%, -50%) translateZ(0px) scale(1) !important;
        opacity: 1 !important;
        z-index: 3;
        filter: blur(0);
    }

    /* 上方位置 - 缩小、向上、向后 */
    .cn .aff-section2 .section2-card.top {
        transform: translate(-50%, -50%) translateY(-100px) translateZ(-100px) scale(0.65) !important;
        -webkit-transform: translate(-50%, -50%) translateY(-100px) translateZ(-100px) scale(0.65) !important;
        opacity: 1 !important;
        z-index: 1;
        pointer-events: none;
    }

    .cn .aff-section2 .section2-card.top .section2-cardDesc,
    .cn .aff-section2 .section2-card.hidden-top .section2-cardDesc {
        color: transparent;
        /* 1. 文字透明 */
        background: linear-gradient(0deg, rgba(255, 255, 255, .9), rgba(255, 255, 255, .3));
        /* 2. 渐变 */
        -webkit-background-clip: text;
        /* 3. 背景只保留文字区域 */
        background-clip: text;
        -webkit-text-fill-color: transparent;
        /* iOS/Safari：避免闪白 */
    }

    .cn .aff-section2 .section2-card.top .section2-cardTitle,
    .cn .aff-section2 .section2-card.hidden-top .section2-cardTitle {
        color: transparent;
        /* 1. 文字透明 */
        background: linear-gradient(0deg, rgba(255, 255, 255, .8), rgba(255, 255, 255, .5));
        /* 2. 渐变 */
        -webkit-background-clip: text;
        /* 3. 背景只保留文字区域 */
        background-clip: text;
        -webkit-text-fill-color: transparent;
        /* iOS/Safari：避免闪白 */
    }

    .cn .aff-section2 .section2-card.bottom .section2-cardDesc,
    .cn .aff-section2 .section2-card.hidden-bottom .section2-cardDesc {
        color: transparent;
        /* 1. 文字透明 */
        background: linear-gradient(180deg, rgba(255, 255, 255, .9), rgba(255, 255, 255, .3));
        /* 2. 渐变 */
        -webkit-background-clip: text;
        /* 3. 背景只保留文字区域 */
        background-clip: text;
        -webkit-text-fill-color: transparent;
        /* iOS/Safari：避免闪白 */
    }

    .cn .aff-section2 .section2-card.bottom .section2-cardTitle,
    .cn .aff-section2 .section2-card.hidden-bottom .section2-cardTitle {
        color: transparent;
        /* 1. 文字透明 */
        background: linear-gradient(180deg, rgba(255, 255, 255, .5), rgba(255, 255, 255, .2));
        /* 2. 渐变 */
        -webkit-background-clip: text;
        /* 3. 背景只保留文字区域 */
        background-clip: text;
        -webkit-text-fill-color: transparent;
        /* iOS/Safari：避免闪白 */
    }

    /* 说明：
     之前在 .top 状态单独改 font-size，会在卡片位移动画中引起自身高度变化，
     配合 translate(-50%, -50%) 造成“先上去再下落”的视觉抖动。
     现在仅依赖卡片自身的 scale(0.85) 来实现远近缩放，保证位移轨迹稳定。 */

    /* 下方位置 - 缩小、向下、向后 */
    .cn .aff-section2 .section2-card.bottom {
        transform: translate(-50%, -50%) translateY(110px) translateZ(-100px) scale(0.65) !important;
        -webkit-transform: translate(-50%, -50%) translateY(110px) translateZ(-100px) scale(0.65) !important;
        opacity: 1 !important;
        z-index: 1;
        pointer-events: none;
    }

    /* 隐藏位置 - 完全消失 */
    .cn .aff-section2 .section2-card.hidden-top {
        transform: translate(-50%, -50%) translateY(-120px) translateZ(-400px) scale(0.5) !important;
        -webkit-transform: translate(-50%, -50%) translateY(-120px) translateZ(-400px) scale(0.5) !important;
        opacity: 0 !important;
        z-index: 0;
        pointer-events: none;
        transition: none !important;
        -webkit-transition: none !important;
    }

    .cn .aff-section2 .section2-card.hidden-bottom {
        transform: translate(-50%, -50%) translateY(120px) translateZ(-400px) scale(0.5) !important;
        -webkit-transform: translate(-50%, -50%) translateY(120px) translateZ(-400px) scale(0.5) !important;
        opacity: 0 !important;
        z-index: 0;
        pointer-events: none;
        transition: none !important;
        -webkit-transition: none !important;
    }
}

@keyframes marquee {
    0% {
        transform: translate3d(0, 0, 0);
    }

    100% {
        transform: translate3d(var(--s7move-distance), 0, 0);
    }
}

.aff-section3 .point-badge {
    position: absolute;
    background: #ff4b4e;
    color: white;
    padding: 6px 14px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 500;
    transform: translate(-50%, calc(-100% - 20px));
    white-space: nowrap;
    cursor: grab;
    z-index: 11;
    pointer-events: none;
}

.aff-section3 .point-badge:active {
    cursor: grabbing;
}

.aff-section3 .point-badge::after {
    content: "";
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #ff4b4e;
    pointer-events: none;
}

.aff-section3 .point-dot {
    position: absolute;
    width: 16px;
    height: 16px;
    background: #ff4b4e;
    border: 4px solid white;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0 2px 8px rgba(255, 75, 78, 0.4);
    cursor: grab;
    z-index: 10;
    pointer-events: none;
}

.aff-section3 .point-dot:active {
    cursor: grabbing;
}
</style>
